import axios from 'axios';
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  ASSIGN_QUESTION_TO_CONDITION_URL,
  BULK_ASSIGN_COMPLIANCE_BY_SCOPE_URL,
  BULK_ASSIGN_COMPLIANCE_QUESTIONS_URL,
  BULK_UNASSIGN_COMPLIANCE_QUESTIONS_URL,
  CHECK_COMPLIANCE_STAGE_GATE_URL,
  CREATE_COMPLIANCE_CONDITION_URL,
  CREATE_COMPLIANCE_RULE_URL,
  UPDATE_COMPLIANCE_CONDITION_URL,
  DELETE_COMPLIANCE_CONDITION_URL,
  DELETE_COMPLIANCE_RULE_URL,
  DELETE_RULE_RESULT_ACTION_URL,
  EVALUATE_COMPLIANCE_URL,
  GET_ALL_FORM_STATUSES_URL,
  GET_ASSIGNED_QUESTIONS_FOR_RULE_URL,
  GET_COMPLIANCE_ANSWER_HISTORY_URL,
  GET_COMPLIANCE_DROPDOWNS_URL,
  GET_COMPLIANCE_RULES_URL,
  GET_ENTITY_TYPE_FORMS_COMPLIANCE_URL,
  GET_FORM_STRUCTURE_URL,
  GET_FORMS_URL,
  GET_RULE_CONDITIONS_URL,
  GET_RULE_RESULT_ACTIONS_URL,
  GET_RULE_QUESTIONS_ANSWERS_URL,
  START_ONGOING_COMPLIANCE_URL,
  SUBMIT_COMPLIANCE_ANSWER_URL,
  SAVE_RULE_RESULT_ACTION_URL,
  SYNC_APPLICATION_ANSWERS_TO_COMPLIANCE_URL,
  UPDATE_COMPLIANCE_RULE_URL,
  get_request_config,
} from '@/utils/system_constants/constant.js';

const QUESTION_TYPE_LABELS = {
  short_text: 'Short Text',
  long_text: 'Long Text',
  single_select: 'Single Select',
  multi_select: 'Multi Select',
  multiple_choice: 'Multiple Choice',
  number: 'Number',
  date: 'Date',
  file: 'File Upload',
  file_upload: 'File Upload',
  facial_verification: 'Facial Verification',
  boolean: 'Yes/No',
  radio: 'Single Select',
  checkbox: 'Multi Select',
  dropdown: 'Single Select',
  text: 'Text',
};

export default {
  name: 'ComplianceManagement',
  mixins: [alert_mixin],
  data() {
    return {
      loading: false,
      saving: false,
      assigning: false,
      testing: false,
      current_view: 'hub',
      active_rule_tab: 'rule_setup',
      hub_filter: 'all',
      hub_sort_order: 'updated_desc',
      selected_rule_id: '',
      selected_form_id: '',
      assignment_method: 'full_form',
      manual_form_id: '',
      manual_question_search: '',
      manual_selected_question_ids: [],
      assignment_question_modal: {
        form_id: '',
        method: 'full_form',
        question_search: '',
        section_filter: '',
        answer_type_filter: '',
        selected_only: false,
        selected_question_ids: [],
        select_all_questions: true,
        expanded_sections: {},
        visible_limit: 120,
      },
      collapsed_manual_sections: {},
      form_structures: {},
      loading_manual_questions: false,
      form_statuses: [],
      rules: [],
      entity_type_forms: [],
      rule_assignments: {},
      modal_error_message: '',
      compliance_dropdowns: {
        condition_types: [],
        operators: [],
        outcomes: [],
        form_statuses: [],
      },
      rule_form: {
        id: null,
        mode: 'create',
        name: '',
        description: '',
        initial_grace_period_days: 7,
        frequency_days: '',
        recurring_grace_period_days: '',
        logical_operator: 'AND',
        trigger_status_id: '',
        status: 'Draft',
        
      },
      test_form: {
        entity_profile_id: '',
        application_id: '',
        application_form_id: '',
        compliance_field_id: '',
        sample_answer: 'Yes',
      },
      test_result_cards: [],
      test_response: null,
      condition_groups: [],
      condition_group_form: {
        id: null,
        mode: 'create',
        name: '',
        logic: 'AND',
        show_validation: false,
        conditions: [],
      },
      configured_actions: [],
      action_form: {
        id: null,
        mode: 'create',
        outcome_type: 'fail',
        action_type: 'Manual Review',
        description: '',
        target_status: 'Manual Review',
      },
      action_outcomes: [
        { id: 'pass', label: 'On Pass', action: 'No Action' },
        { id: 'fail', label: 'On Fail', action: 'Manual Review' },
        { id: 'manual_review', label: 'On Manual Review', action: 'Manual Review' },
        { id: 'expired', label: 'On Expired', action: 'Escalate' },
        { id: 'missing_data', label: 'On Missing Data', action: 'Manual Review' },
      ],
      available_result_actions: ['Approve', 'Reject', 'Manual Review', 'Escalate', 'Suspend', 'No Action'],
      assignment_search: '',
      assignment_targets: [],
      question_search: '',
      required_question_modal: {
        search: '',
        form_id: '',
        section: '',
        answer_type: '',
        selected_only: false,
        working_ids: [],
        expanded_sections: {},
        visible_limit: 160,
      },
      conditional_requirement_form: {
        id: null,
        trigger_question_id: '',
        operator: '=',
        trigger_value: '',
        required_question_ids: [],
      },
      conditional_question_search: '',
      conditional_question_picker_open: false,
      selected_preview_question_id: '',
      selected_workflow_trigger: 'Assessment Completed',
      selected_trigger_source: 'Audit Submission',
      access_control: {
        read_only_mode: false,
        approval_required: true,
        restricted_actions: true,
        editor_role: 'Compliance Administrator',
      },
      auto_save_status: 'Saved just now',
      governance_approval_status: 'Approval required before publish',
      rule_versions: [
        { version: 'v1.0', status: 'Published', by: 'System admin', date: 'Current draft', summary: 'Initial rule configuration created.' },
        { version: 'v0.9', status: 'Draft', by: 'Compliance admin', date: 'Previous edit', summary: 'Updated trigger status and assignments.' },
      ],
      simulation: {
        sample_submission: '',
        matched: false,
        timeline: [],
        output_cards: [],
      },
      onboarding_gate_by_rule: {},
      notification_settings: {
        reminders_enabled: true,
        reminder_interval_days: 7,
        email_enabled: true,
        sms_enabled: false,
        in_app_enabled: true,
      },
      escalation_settings: {
        enabled: false,
        after_days: 14,
        notify_managers: true,
        create_incident: false,
      },
      operators: ['AND', 'OR', 'XOR'],
      rule_tabs: [
        { id: 'rule_setup', label: 'Rule Setup', icon: 'bi-sliders' },
        { id: 'forms_questions', label: 'Forms & Questions', short_label: 'Forms', icon: 'bi-ui-checks-grid' },
        { id: 'onboarding_gate', label: 'Onboarding Requirements', short_label: 'Requirements', icon: 'bi-door-open' },
        { id: 'conditions', label: 'Conditions', icon: 'bi-diagram-3' },
        { id: 'actions', label: 'Actions', icon: 'bi-lightning-charge' },
        { id: 'ongoing', label: 'Ongoing Compliance', short_label: 'Ongoing', icon: 'bi-arrow-repeat' },
        { id: 'review_publish', label: 'Review & Publish', short_label: 'Review', icon: 'bi-shield-check' },
      ],
      entity_sources: ['Employee Document', 'Vendor Assessment', 'Audit Submission', 'Entity Profile', 'Compliance Answer'],
      source_fields: [
        { source: 'Employee Document', field: 'Expiry Date', type: 'Date', samples: ['Today', '2026-06-01', 'Expired'] },
        { source: 'Vendor Assessment', field: 'Compliance Score', type: 'Number', samples: ['65', '72', '80'] },
        { source: 'Audit Submission', field: 'Status', type: 'Multiple choice', samples: ['Failed', 'Passed', 'Manual Review'] },
        { source: 'Entity Profile', field: 'Risk Rating', type: 'Rating', samples: ['High', 'Medium', 'Low'] },
        { source: 'Compliance Answer', field: 'Answer Value', type: 'Text', samples: ['Yes', 'No', 'Missing'] },
      ],
      question_type_operators: {
        Text: ['contains', 'starts_with', '=', '!='],
        short_text: ['contains', 'starts_with', '=', '!='],
        long_text: ['contains', 'starts_with', '=', '!='],
        Number: ['>', '<', '>=', '<=', '=', '!='],
        number: ['>', '<', '>=', '<=', '=', '!='],
        Date: ['=', '!=', '>', '<', '>=', '<='],
        date: ['=', '!=', '>', '<', '>=', '<='],
        Boolean: ['=', '!='],
        boolean: ['=', '!='],
        'Multiple choice': ['=', '!=', 'contains'],
        Rating: ['>', '<', '>=', '<=', '=', '!='],
        Percentage: ['>', '<', '>=', '<=', '=', '!='],
        'File upload status': ['=', '!='],
      },
      available_condition_fields: ['Expiry Date', 'Compliance Score', 'Document Status', 'Risk Rating', 'Answer Value'],
      available_condition_operators: ['=', '!=', '>', '<', '>=', '<=', 'contains', 'is empty', 'is not empty'],
      action_catalog: [
        { action: 'Send Email', icon: 'bi-envelope', priority: 'Medium' },
        { action: 'Send SMS', icon: 'bi-chat-dots', priority: 'High' },
        { action: 'Trigger In-App Notification', icon: 'bi-bell', priority: 'Medium' },
        { action: 'Create Compliance Incident', icon: 'bi-exclamation-octagon', priority: 'High' },
        { action: 'Escalate Case', icon: 'bi-arrow-up-right-circle', priority: 'High' },
        { action: 'Assign Reviewer', icon: 'bi-person-check', priority: 'Medium' },
        { action: 'Lock Submission', icon: 'bi-lock', priority: 'High' },
        { action: 'Mark Record Non-Compliant', icon: 'bi-shield-fill-exclamation', priority: 'High' },
        { action: 'Create Audit Log', icon: 'bi-journal-check', priority: 'Low' },
        { action: 'Trigger Workflow', icon: 'bi-diagram-3', priority: 'Medium' },
        { action: 'Require Reassessment', icon: 'bi-arrow-repeat', priority: 'Medium' },
        { action: 'Generate Compliance Task', icon: 'bi-list-check', priority: 'Medium' },
        { action: 'Notify Compliance Officer', icon: 'bi-person-badge', priority: 'High' },
        { action: 'Create Investigation', icon: 'bi-search', priority: 'High' },
        { action: 'Trigger Approval Workflow', icon: 'bi-check2-square', priority: 'High' },
      ],
      workflow_triggers: ['Submission Approved', 'Audit Failed', 'Assessment Completed', 'Document Expired', 'High Risk Detected'],
    };
  },
  computed: {
    route_entity_type_id() {
      const entity_type_id = Number(this.$route?.query?.entityTypeId || this.$route?.query?.entity_type_id || 0);
      return Number.isFinite(entity_type_id) && entity_type_id > 0 ? entity_type_id : null;
    },
    normalized_rules() {
      return this.rules.map((rule) => this.normalize_rule(rule));
    },
    selected_rule() {
      return this.normalized_rules.find((rule) => String(rule.id) === String(this.selected_rule_id)) || null;
    },
    selected_rule_forms() {
      if (!this.selected_rule_id) return [];
      return this.rule_assignment_forms(this.selected_rule_id).map((form) => ({
        ...form,
        section_names: this.extract_section_names(form),
        total_questions_count: this.total_questions_for_form(form.form_id),
        assigned_questions_count: this.count_assigned_questions([form]),
        used_questions_count: this.count_form_questions_used_in_conditions(form.form_id),
        assignment_method_label: this.assignment_method_for_form(form),
        updated_label: this.form_updated_label(form.form_id),
        health_status: this.count_assigned_questions([form]) ? 'Configured' : 'Needs Questions',
      }));
    },
    selected_rule_questions() {
      if (!this.selected_rule_id) return [];
      return this.flatten_assignment_forms(this.rule_assignment_forms(this.selected_rule_id), this.selected_rule);
    },
    current_onboarding_gate() {
      return this.onboarding_gate_by_rule[String(this.selected_rule_id)] || this.default_onboarding_gate();
    },
    onboarding_required_question_ids() {
      if (this.current_onboarding_gate.require_all_assigned) {
        return this.selected_rule_questions.map((question) => this.question_key(question));
      }
      return (this.current_onboarding_gate.required_question_ids || []).map(String);
    },
    onboarding_required_questions() {
      const required_ids = new Set(this.onboarding_required_question_ids);
      return this.selected_rule_questions.filter((question) => required_ids.has(this.question_key(question)));
    },
    onboarding_required_question_groups() {
      const groups = new Map();
      this.onboarding_required_questions.forEach((question) => {
        const name = question.section_name || question.main_section_name || 'General';
        if (!groups.has(name)) groups.set(name, []);
        groups.get(name).push(question);
      });
      return [...groups.entries()].slice(0, 3).map(([name, questions]) => ({ name, questions }));
    },
    onboarding_required_selection_label() {
      const selected_count = this.onboarding_required_questions.length;
      const total_count = this.selected_rule_questions.length;
      if (!total_count) return 'No assigned questions available.';
      if (!selected_count) return 'No required questions selected.';
      return `${selected_count} selected`;
    },
    onboarding_required_questions_more_count() {
      const visible_count = this.onboarding_required_question_groups.reduce((total, group) => total + Math.min(group.questions.length, 4), 0);
      return Math.max(this.onboarding_required_questions.length - visible_count, 0);
    },
    onboarding_conditional_requirements() {
      return this.safe_array(this.current_onboarding_gate.conditional_requirements).map((requirement) => ({
        operator: '=',
        ...requirement,
        required_question_ids: this.conditional_required_question_ids(requirement),
      }));
    },
    onboarding_gate_complete() {
      return this.forms_questions_complete && (
        this.current_onboarding_gate.require_all_assigned ||
        this.onboarding_required_question_ids.length > 0 ||
        this.onboarding_conditional_requirements.length > 0
      );
    },
    selected_rule_form_filters() {
      const forms = new Map();
      this.selected_rule_questions.forEach((question) => {
        const id = String(question.form_id || question.application_form_id || question.form_name || '');
        if (id) forms.set(id, question.form_name || question.form_label || `Form ${id}`);
      });
      return [...forms.entries()].map(([id, label]) => ({ id, label }));
    },
    selected_rule_sections() {
      return [...new Set(this.selected_rule_questions.map((question) => question.section_name).filter(Boolean))];
    },
    selected_rule_answer_types() {
      return [...new Set(this.selected_rule_questions.map((question) => this.raw_question_type(question)).filter(Boolean))]
        .map((value) => ({ value, label: this.question_type_label(value) }))
        .sort((first, second) => first.label.localeCompare(second.label));
    },
    filtered_required_modal_questions() {
      const search = String(this.required_question_modal.search || '').toLowerCase();
      const form_id = String(this.required_question_modal.form_id || '');
      const section = String(this.required_question_modal.section || '');
      const answer_type = String(this.required_question_modal.answer_type || '');
      const selected_ids = new Set(this.required_question_modal.working_ids.map(String));
      return this.selected_rule_questions.filter((question) => {
        const question_form_id = String(question.form_id || question.application_form_id || question.form_name || '');
        const question_type = String(this.raw_question_type(question) || '');
        const text = [
          question.form_name,
          question.section_name,
          question.question_text,
          question_type,
          this.question_type_label(question_type),
          question.compliance_field_label,
        ].join(' ').toLowerCase();
        return (!search || text.includes(search)) &&
          (!form_id || question_form_id === form_id) &&
          (!section || String(question.section_name || '') === section) &&
          (!answer_type || question_type === answer_type) &&
          (!this.required_question_modal.selected_only || selected_ids.has(this.question_key(question)));
      });
    },
    all_visible_required_questions_selected() {
      if (!this.filtered_required_modal_questions.length) return false;
      const selected_ids = new Set(this.required_question_modal.working_ids.map(String));
      return this.filtered_required_modal_questions.every((question) => selected_ids.has(this.question_key(question)));
    },
    all_assigned_required_questions_selected() {
      return this.selected_rule_questions.length > 0 && this.required_question_modal.working_ids.length === this.selected_rule_questions.length;
    },
    some_assigned_required_questions_selected() {
      return this.required_question_modal.working_ids.length > 0 && !this.all_assigned_required_questions_selected;
    },
    required_question_modal_summary() {
      const selected_count = this.required_question_modal.working_ids.length;
      const total_count = this.selected_rule_questions.length;
      if (!total_count) return 'No questions available';
      return `${selected_count} of ${total_count} selected`;
    },
    required_modal_question_groups() {
      const groups = new Map();
      this.filtered_required_modal_questions.slice(0, this.required_question_modal.visible_limit).forEach((question) => {
        const name = question.section_name || question.main_section_name || 'General';
        if (!groups.has(name)) groups.set(name, []);
        groups.get(name).push(question);
      });
      const selected_ids = new Set(this.required_question_modal.working_ids.map(String));
      return [...groups.entries()].map(([name, questions], index) => ({
        name,
        questions,
        selected_count: questions.filter((question) => selected_ids.has(this.question_key(question))).length,
        expanded: this.required_question_modal.expanded_sections[name] !== false && index < 8,
      }));
    },
    has_more_required_modal_questions() {
      return this.filtered_required_modal_questions.length > this.required_question_modal.visible_limit;
    },
    conditional_question_search_results() {
      const search = String(this.conditional_question_search || '').toLowerCase();
      if (!search) return this.selected_rule_questions;
      return this.selected_rule_questions.filter((question) => [
        question.question_text,
        question.form_name,
        question.section_name,
        this.question_type_label(question),
        this.question_type_label(question),
      ].join(' ').toLowerCase().includes(search));
    },
    conditional_trigger_question() {
      return this.selected_rule_questions.find((question) => this.question_key(question) === String(this.conditional_requirement_form.trigger_question_id)) || null;
    },
    conditional_trigger_answer_options() {
      return this.answer_options_for_question(this.conditional_trigger_question);
    },
    conditional_trigger_uses_options() {
      if (!this.conditional_trigger_question) return false;
      if (this.conditional_trigger_answer_options.length) return true;
      const type = String(this.conditional_trigger_question.question_type || this.conditional_trigger_question.answer_type || '').toLowerCase();
      return ['radio', 'select', 'dropdown', 'checkbox', 'multi-select', 'multiselect', 'multiple choice', 'multiple_choice'].some((item) => type.includes(item));
    },
    conditional_required_question_options() {
      const trigger_id = String(this.conditional_requirement_form.trigger_question_id || '');
      return this.selected_rule_questions.filter((question) => this.question_key(question) !== trigger_id);
    },
    conditional_preview_required_labels() {
      return this.conditional_requirement_form.required_question_ids.map((id) => this.question_label_by_id(id));
    },
    filtered_rule_questions() {
      const search = String(this.question_search || '').toLowerCase();
      if (!search) return this.selected_rule_questions;
      return this.selected_rule_questions.filter((question) => (
        [
          question.form_name,
          question.section_name,
          question.question_text,
        this.question_type_label(question),
          question.compliance_field_label,
        ].join(' ').toLowerCase().includes(search)
      ));
    },
    recent_question_samples() {
      const samples = ['65', '72', '80'];
      if (!this.selected_preview_question) return samples;
      if (String(this.selected_preview_question.question_type || '').toLowerCase().includes('boolean')) return ['Yes', 'No', 'Yes'];
      if (String(this.selected_preview_question.question_type || '').toLowerCase().includes('date')) return ['2026-05-18', '2026-06-01', 'Expired'];
      return samples;
    },
    selected_preview_question() {
      return this.selected_rule_questions.find((question) => String(question.id || question.section_question_id) === String(this.selected_preview_question_id)) || this.selected_rule_questions[0] || null;
    },
    condition_question_ids() {
      return new Set(this.collect_condition_question_ids(this.condition_groups));
    },
    questions_used_in_conditions() {
      return this.selected_rule_questions.filter((question) => this.is_question_used_in_conditions(question));
    },
    unused_assigned_questions() {
      return this.selected_rule_questions.filter((question) => !this.is_question_used_in_conditions(question));
    },
    missing_condition_question_count() {
      const assigned_ids = new Set(this.selected_rule_questions.flatMap((question) => this.question_reference_ids(question)));
      return [...this.condition_question_ids].filter((id) => !assigned_ids.has(String(id))).length;
    },
    full_form_assignment_count() {
      return this.selected_rule_forms.filter((form) => form.assignment_method_label === 'Full Form').length;
    },
    manual_assignment_count() {
      return Math.max(this.selected_rule_forms.length - this.full_form_assignment_count, 0);
    },
    rule_insight_items() {
      return [
        { label: 'Assigned Forms', value: this.selected_rule_forms.length },
        { label: 'Assigned Questions', value: this.selected_rule_questions.length },
        { label: 'Questions Used In Conditions', value: this.questions_used_in_conditions.length },
        { label: 'Unused Questions', value: this.unused_assigned_questions.length },
        { label: 'Full Form Assignments', value: this.full_form_assignment_count },
        { label: 'Manual Question Assignments', value: this.manual_assignment_count },
        { label: 'Missing Logic', value: this.rule_condition_count ? 'No' : 'Yes' },
        { label: 'Missing Trigger Status', value: this.selected_rule?.trigger_status_label ? 'No' : 'Yes' },
      ];
    },
    forms_question_summary_cards() {
      const next_label = this.forms_questions_complete ? 'Continue to Conditions' : 'Assign data first';
      return [
        { label: 'Assigned Forms', value: this.selected_rule_forms.length, icon: 'bi-ui-checks-grid' },
        { label: 'Available Questions', value: `${this.selected_rule_questions.length} for evaluation`, icon: 'bi-question-circle' },
        { label: 'Question Selection', value: this.forms_questions_complete ? 'Configured per form' : 'Choose after form select', icon: 'bi-list-check' },
        { label: 'Next Step', value: next_label, icon: 'bi-arrow-right-circle' },
      ];
    },
    assignable_entity_type_forms() {
      return this.entity_type_forms;
    },
    selected_form_is_available() {
      return this.assignable_entity_type_forms.some((form) => String(form.id) === String(this.selected_form_id));
    },
    selected_manual_form_sections() {
      const form_id = this.manual_form_id;
      if (!form_id) return [];
      const search = String(this.manual_question_search || '').trim().toLowerCase();
      return this.normalized_form_sections(form_id)
        .map((section) => ({
          ...section,
          questions: section.questions.filter((question) => !search || [
            question.question_text,
            question.section_name,
          this.question_type_label(question),
          ].join(' ').toLowerCase().includes(search)),
        }))
        .filter((section) => section.questions.length);
    },
    manual_visible_question_ids() {
      return this.selected_manual_form_sections.flatMap((section) => section.questions.map((question) => String(question.section_question_id)));
    },
    all_manual_visible_selected() {
      return this.manual_visible_question_ids.length > 0 && this.manual_visible_question_ids.every((id) => this.manual_selected_question_ids.includes(id));
    },
    assignment_modal_form() {
      return this.entity_type_forms.find((form) => String(form.id) === String(this.assignment_question_modal.form_id)) || null;
    },
    assignment_modal_form_questions() {
      if (!this.assignment_question_modal.form_id) return [];
      return this.normalized_form_sections(this.assignment_question_modal.form_id).flatMap((section) => (
        section.questions.map((question) => ({
          ...question,
          section_name: question.section_name || section.section_name,
        }))
      ));
    },
    filtered_assignment_modal_questions() {
      const search = String(this.assignment_question_modal.question_search || '').trim().toLowerCase();
      const selected_ids = new Set(this.assignment_question_modal.selected_question_ids.map(String));
      const section_filter = String(this.assignment_question_modal.section_filter || '');
      const answer_type_filter = String(this.assignment_question_modal.answer_type_filter || '');
      const questions = this.assignment_modal_form_questions.filter((question) => {
        const selected = selected_ids.has(String(question.section_question_id));
        const question_type = String(this.raw_question_type(question) || '');
        const matches_search = !search || [
          question.question_text,
          question.section_name,
          question_type,
          this.question_type_label(question_type),
        ].join(' ').toLowerCase().includes(search);
        return matches_search &&
          (!section_filter || String(question.section_name || '') === section_filter) &&
          (!answer_type_filter || question_type === answer_type_filter) &&
          (!this.assignment_question_modal.selected_only || selected);
      });
      return questions.slice(0, this.assignment_question_modal.visible_limit);
    },
    assignment_modal_filtered_total_count() {
      const search = String(this.assignment_question_modal.question_search || '').trim().toLowerCase();
      const selected_ids = new Set(this.assignment_question_modal.selected_question_ids.map(String));
      const section_filter = String(this.assignment_question_modal.section_filter || '');
      const answer_type_filter = String(this.assignment_question_modal.answer_type_filter || '');
      return this.assignment_modal_form_questions.filter((question) => {
        const question_type = String(this.raw_question_type(question) || '');
        return (!search || [
          question.question_text,
          question.section_name,
          question_type,
          this.question_type_label(question_type),
        ].join(' ').toLowerCase().includes(search)) &&
          (!section_filter || String(question.section_name || '') === section_filter) &&
          (!answer_type_filter || question_type === answer_type_filter) &&
          (!this.assignment_question_modal.selected_only || selected_ids.has(String(question.section_question_id)));
      }).length;
    },
    assignment_modal_has_more_filtered_questions() {
      return this.assignment_modal_filtered_total_count > this.filtered_assignment_modal_questions.length;
    },
    assignment_modal_section_filters() {
      return [...new Set(this.assignment_modal_form_questions.map((question) => question.section_name).filter(Boolean))];
    },
    assignment_modal_answer_type_filters() {
      return [...new Set(this.assignment_modal_form_questions.map((question) => this.raw_question_type(question)).filter(Boolean))]
        .map((value) => ({ value, label: this.question_type_label(value) }))
        .sort((first, second) => first.label.localeCompare(second.label));
    },
    assignment_modal_mode_label() {
      return this.assignment_question_modal.method === 'full_form' ? 'All Questions' : 'Selected Questions Only';
    },
    assignment_modal_form_sections() {
      const selected_ids = new Set(this.assignment_question_modal.selected_question_ids.map(String));
      const visible_ids = new Set(this.filtered_assignment_modal_questions.map((question) => String(question.section_question_id)));
      return this.normalized_form_sections(this.assignment_question_modal.form_id)
        .map((section) => {
          const questions = (section.questions || []).filter((question) => visible_ids.has(String(question.section_question_id)));
          const selected_count = (section.questions || []).filter((question) => selected_ids.has(String(question.section_question_id))).length;
          return {
            ...section,
            questions,
            selected_count: this.assignment_question_modal.method === 'full_form' ? (section.questions || []).length : selected_count,
            total_count: (section.questions || []).length,
          };
        })
        .filter((section) => section.questions.length);
    },
    assignment_modal_selected_count() {
      return this.assignment_question_modal.method === 'full_form'
        ? (this.assignment_question_modal.select_all_questions ? this.assignment_modal_form_questions.length : 0)
        : this.assignment_question_modal.selected_question_ids.length;
    },
    rule_setup_complete() {
      return Boolean(
        this.selected_rule?.id &&
        this.selected_rule?.name &&
        this.selected_rule?.logic &&
        this.selected_rule?.trigger_status_label &&
        Number(this.selected_rule?.initial_grace_period_days) > 0
      );
    },
    forms_questions_complete() {
      return this.selected_rule_forms.length > 0 && this.selected_rule_questions.length > 0;
    },
    conditions_complete() {
      return this.valid_condition_count > 0 && this.invalid_condition_count === 0;
    },
    compliance_evaluation_required() {
      return this.configured_actions.some((action) => action.enabled && action.action !== 'No Action');
    },
    actions_complete() {
      return this.configured_actions.some((action) => action.enabled);
    },
    ongoing_complete() {
      const frequency = Number(this.rule_form.frequency_days || this.selected_rule?.frequency_days || 0);
      const initial_grace = Number(this.rule_form.initial_grace_period_days || this.selected_rule?.initial_grace_period_days || 0);
      const recurring_grace = Number(this.rule_form.recurring_grace_period_days || this.selected_rule?.recurring_grace_period_days || 0);
      return initial_grace >= 0 && frequency >= 0 && (!frequency || recurring_grace >= 0);
    },
    ready_to_publish() {
      return this.rule_setup_complete && this.forms_questions_complete && this.onboarding_gate_complete && this.conditions_complete && this.actions_complete && this.ongoing_complete && !this.blocking_validation_issues.length;
    },
    setup_steps() {
      return this.rule_tabs.map((step, index) => {
        const complete_map = {
          rule_setup: this.rule_setup_complete,
          forms_questions: this.forms_questions_complete,
          onboarding_gate: this.onboarding_gate_complete,
          conditions: this.conditions_complete,
          actions: this.actions_complete,
          ongoing: this.ongoing_complete,
          review_publish: this.ready_to_publish,
        };
        const attention_map = {
          rule_setup: !this.rule_setup_complete,
          forms_questions: this.rule_setup_complete && !this.forms_questions_complete,
          onboarding_gate: this.forms_questions_complete && !this.onboarding_gate_complete,
          conditions: this.onboarding_gate_complete && !this.conditions_complete,
          actions: this.conditions_complete && !this.actions_complete,
          ongoing: false,
          review_publish: !this.ready_to_publish,
        };
        const unlocked = this.is_step_unlocked(step.id);
        const status = !unlocked ? 'Locked' : complete_map[step.id] ? 'Complete' : step.id === this.active_rule_tab ? 'In Progress' : attention_map[step.id] ? 'Needs Attention' : index < this.current_step_index ? 'In Progress' : 'Not Started';
        return {
          ...step,
          number: index + 1,
          status,
          complete: Boolean(complete_map[step.id]),
          unlocked,
        };
      });
    },
    current_step_index() {
      return Math.max(this.rule_tabs.findIndex((step) => step.id === this.active_rule_tab), 0);
    },
    active_setup_step() {
      return this.setup_steps.find((step) => step.id === this.active_rule_tab) || this.setup_steps[0];
    },
    completed_setup_steps_count() {
      return this.setup_steps.filter((step) => step.complete).length;
    },
    missing_setup_requirements() {
      const items = [];
      if (!this.rule_setup_complete) items.push('Save rule setup to the backend with name, logic, trigger status, and grace period.');
      if (!this.forms_questions_complete) items.push('Assign at least one form and one question.');
      if (!this.onboarding_gate_complete) items.push('Configure which onboarding fields must be answered before the stage can move.');
      if (!this.conditions_complete) items.push('Add evaluation conditions using assigned questions.');
      if (!this.actions_complete) items.push('Choose at least one result action.');
      if (!this.ongoing_complete) items.push('Confirm onboarding or ongoing compliance settings.');
      return items;
    },
    next_required_step() {
      return this.setup_steps.find((step) => !step.complete) || this.setup_steps[this.setup_steps.length - 1];
    },
    next_evaluation_label() {
      const frequency = Number(this.rule_form.frequency_days || this.selected_rule?.frequency_days || 0);
      if (!frequency) return 'This is an onboarding-only rule. It will not re-evaluate on a recurring schedule.';
      return `This rule will re-evaluate every ${frequency} day${frequency === 1 ? '' : 's'}.`;
    },
    rule_condition_count() {
      return this.condition_groups.reduce((total, group) => (
        total + (group.conditions || []).length + (group.children || []).reduce((child_total, child) => child_total + (child.conditions || []).length, 0)
      ), 0);
    },
    valid_condition_count() {
      return this.flatten_condition_rows(this.condition_groups).filter((condition) => this.condition_row_complete(condition)).length;
    },
    invalid_condition_count() {
      return this.flatten_condition_rows(this.condition_groups).filter((condition) => !this.condition_row_complete(condition)).length;
    },
    enabled_actions_count() {
      return this.configured_actions.filter((action) => action.enabled).length;
    },
    action_target_status_options() {
      const dropdown_statuses = (this.compliance_dropdowns.form_statuses || []).map((status) => status.status || status.name).filter(Boolean);
      const form_statuses = (this.form_statuses || []).map((status) => status.status || status.name).filter(Boolean);
      return [...new Set([...dropdown_statuses, ...form_statuses, 'Approved', 'Rejected', 'Manual Review', 'Escalated', 'In Progress'])];
    },
    validation_checks() {
      const rule = this.selected_rule || {};
      return [
        { label: 'Rule Setup Complete', ok: this.rule_setup_complete, severity: 'critical' },
        { label: 'Forms Assigned', ok: this.selected_rule_forms.length > 0 || Number(rule.assigned_forms_count) > 0, severity: 'critical' },
        { label: 'Questions Selected', ok: this.selected_rule_questions.length > 0 || Number(rule.assigned_questions_count) > 0, severity: 'critical' },
        { label: 'Onboarding Requirements Configured', ok: this.onboarding_gate_complete, severity: 'critical' },
        { label: 'Valid Conditions Configured', ok: this.conditions_complete, severity: 'critical' },
        { label: 'Actions Configured', ok: this.actions_complete, severity: 'critical' },
        { label: 'Ongoing Compliance Configured', ok: this.ongoing_complete, severity: 'critical' },
      ];
    },
    publish_readiness_score() {
      if (!this.validation_checks.length) return 0;
      return Math.round((this.validation_checks.filter((check) => check.ok).length / this.validation_checks.length) * 100);
    },
    blocking_validation_issues() {
      return this.validation_checks.filter((check) => !check.ok && check.severity === 'critical');
    },
    warning_validation_issues() {
      return this.validation_checks.filter((check) => !check.ok && check.severity !== 'critical');
    },
    publication_readiness_label() {
      return this.ready_to_publish ? 'Ready to Publish' : 'Blocked';
    },
    publication_readiness_class() {
      return this.ready_to_publish ? 'bg-success-subtle text-success' : 'bg-warning-subtle text-dark';
    },
    configuration_health_class() {
      if (this.publish_readiness_score < 40) return 'health-progress-fill-risk';
      if (this.publish_readiness_score < 75) return 'health-progress-fill-warning';
      return 'health-progress-fill-ready';
    },
    sidebar_validation_items() {
      const tab = this.active_rule_tab;
      const items = this.sidebar_validation_items_for_tab(tab);

      if (!items.length && this.warning_validation_issues.length && tab !== 'review_publish') {
        return this.warning_validation_issues.slice(0, 3).map((issue) => this.validation_item('warning', issue.label));
      }
      return items;
    },
    sidebar_next_step() {
      const guide = {
        rule_setup: {
          target: 'forms_questions',
          title: 'Assign forms and questions.',
          description: 'Define what this rule evaluates by assigning full forms or selected questions.',
          button: 'Go To Forms & Questions',
          disabled: !this.is_step_unlocked('forms_questions'),
        },
        forms_questions: {
          target: 'onboarding_gate',
          title: 'Configure onboarding gate.',
          description: 'Choose which assigned fields must be answered before onboarding can move forward.',
          button: 'Go To Onboarding Requirements',
          disabled: !this.is_step_unlocked('onboarding_gate'),
        },
        onboarding_gate: {
          target: 'conditions',
          title: 'Configure evaluation conditions.',
          description: 'Use assigned questions to define the IF logic for compliance evaluation.',
          button: 'Go To Conditions',
          disabled: !this.is_step_unlocked('conditions'),
        },
        conditions: {
          target: 'actions',
          title: 'Configure evaluation actions.',
          description: 'Choose what happens when the rule passes, fails, expires, or needs review.',
          button: 'Go To Actions',
          disabled: !this.is_step_unlocked('actions'),
        },
        actions: {
          target: 'ongoing',
          title: 'Confirm ongoing compliance behavior.',
          description: 'Decide whether this rule runs once during onboarding or on a recurring schedule.',
          button: 'Go To Ongoing Compliance',
          disabled: !this.is_step_unlocked('ongoing'),
        },
        ongoing: {
          target: 'review_publish',
          title: 'Review validation and publish.',
          description: 'Confirm readiness, resolve blockers, and publish the rule when validation passes.',
          button: 'Go To Review & Publish',
          disabled: !this.is_step_unlocked('review_publish'),
        },
        review_publish: {
          target: this.ready_to_publish ? 'review_publish' : this.next_required_step?.id || 'rule_setup',
          title: this.ready_to_publish ? 'Ready to publish.' : 'Resolve publish blockers.',
          description: this.ready_to_publish ? 'All required configuration is complete.' : 'Open the first incomplete step and clear the remaining validation issues.',
          button: this.ready_to_publish ? 'Ready to Publish' : `Go To ${this.next_required_step?.label || 'Required Step'}`,
          disabled: this.ready_to_publish ? true : !this.is_step_unlocked(this.next_required_step?.id || 'rule_setup'),
        },
      };
      return guide[this.active_rule_tab] || guide.rule_setup;
    },
    enterprise_metrics() {
      return [
        { label: 'Trigger Count', value: this.test_result_cards.length || 0, icon: 'bi-lightning-charge' },
        { label: 'Last Triggered', value: this.test_result_cards.length ? 'This session' : 'Never', icon: 'bi-clock-history' },
        { label: 'Assigned Entities', value: this.assignment_targets.length || 0, icon: 'bi-building' },
        { label: 'Active Incidents', value: this.configured_actions.some((action) => action.action === 'Create Compliance Incident') ? 1 : 0, icon: 'bi-exclamation-triangle' },
      ];
    },
    execution_flow_steps() {
      const actions = this.configured_actions.filter((action) => action.enabled).slice(0, 4);
      return [
        { label: 'IF mapped question conditions match', icon: 'bi-funnel' },
        { label: `${this.selected_rule?.trigger_status_label || 'Trigger state'} is reached`, icon: 'bi-lightning-charge' },
        ...actions.map((action) => ({ label: action.action, icon: action.icon })),
        { label: 'Audit log captured', icon: 'bi-journal-check' },
      ];
    },
    displayed_rules() {
      const filter_value = String(this.hub_filter || 'all').toLowerCase();
      const sort_value = String(this.hub_sort_order || 'updated_desc').toLowerCase();

      const filtered = this.normalized_rules.filter((rule) => {
        if (filter_value === 'all') return true;
        if (filter_value === 'active') return rule.status === 'Active';
        if (filter_value === 'needs_questions') return rule.assigned_questions_count === 0;
        if (filter_value === 'needs_forms') return rule.assigned_forms_count === 0;
        if (filter_value === 'recurring') return Number(rule.frequency_days) > 0;
        if (filter_value === 'onboarding') return !Number(rule.frequency_days);
        if (filter_value === 'ongoing') return Number(rule.frequency_days) > 0;
        return true;
      });

      return [...filtered].sort((first, second) => {
        if (sort_value === 'updated_asc') return first.updated_sort - second.updated_sort;
        if (sort_value === 'most_questions') return second.assigned_questions_count - first.assigned_questions_count;
        if (sort_value === 'most_forms') return second.assigned_forms_count - first.assigned_forms_count;
        return second.updated_sort - first.updated_sort;
      });
    },
    rule_summary_cards() {
      const rule = this.selected_rule || {};
      return [
        { label: 'Assigned Forms', value: rule.assigned_forms_count || 0, icon: 'bi-ui-checks-grid' },
        { label: 'Assigned Questions', value: rule.assigned_questions_count || 0, icon: 'bi-question-circle' },
        { label: 'Required Onboarding Questions', value: this.onboarding_required_questions.length, icon: 'bi-door-open' },
        { label: 'Conditional Rules', value: this.onboarding_conditional_requirements.length, icon: 'bi-signpost-split' },
        { label: 'Conditions', value: this.rule_condition_count, icon: 'bi-diagram-3' },
        { label: 'Actions', value: this.enabled_actions_count, icon: 'bi-lightning-charge' },
      ];
    },
    selected_rule_health_score() {
      if (!this.selected_rule) return 0;
      const checks = [
        Boolean(this.selected_rule.name),
        Boolean(this.selected_rule.logic),
        Boolean(this.selected_rule.trigger_status_label),
        this.selected_rule.assigned_forms_count > 0,
        this.selected_rule.assigned_questions_count > 0,
        this.conditions_complete,
        !Number(this.selected_rule.frequency_days) || Boolean(this.selected_rule.recurring_grace_period_days || this.selected_rule.frequency_days),
      ];
      return Math.round((checks.filter(Boolean).length / checks.length) * 100);
    },
    selected_rule_warnings() {
      const rule = this.selected_rule;
      if (!rule) return [];
      const warnings = [];
      if (!rule.assigned_forms_count) warnings.push('No forms assigned.');
      if (!rule.assigned_questions_count) warnings.push('No questions assigned.');
      if (this.invalid_condition_count) warnings.push('One or more conditions are incomplete.');
      if (!rule.trigger_status_label) warnings.push('Trigger status missing.');
      if (Number(rule.frequency_days) > 0 && !Number(rule.recurring_grace_period_days)) warnings.push('Recurring frequency is configured without recurring grace days.');
      return warnings;
    },
    selected_rule_missing_configuration_label() {
      return this.selected_rule_warnings.length ? this.selected_rule_warnings.join(' ') : 'None';
    },
    testing_steps() {
      return [
        'Onboarding Gate Runtime: Sync onboarding answers',
        'Onboarding Gate Runtime: Check required onboarding fields',
        'Onboarding Gate Runtime: Show missing fields',
        'Onboarding Gate Runtime: Continue only if can_continue = true',
        'Ongoing Compliance Runtime: Start ongoing compliance',
        'Ongoing Compliance Runtime: Check latest compliance status',
        'Ongoing Compliance Runtime: Show due/expired/unanswered status',
        'Ongoing Compliance Runtime: Show answer history',
      ];
    },
    audit_events() {
      const events = [
        {
          title: 'Rule created',
          meta: `${this.selected_rule?.created_by || 'System admin'} | ${this.selected_rule?.updated_label || 'Not saved yet'}`,
          icon: 'bi-plus-circle',
        },
        {
          title: 'Rule configuration loaded',
          meta: `${this.selected_rule_forms.length} forms and ${this.selected_rule_questions.length} questions currently assigned`,
          icon: 'bi-arrow-repeat',
        },
      ];
      if (this.selected_rule?.trigger_status_label) {
        events.push({
          title: 'Trigger status configured',
          meta: this.selected_rule.trigger_status_label,
          icon: 'bi-lightning-charge',
        });
      }
      if (Number(this.selected_rule?.frequency_days)) {
        events.push({
          title: 'Recurring schedule configured',
          meta: `Every ${this.selected_rule.frequency_days} days`,
          icon: 'bi-calendar2-check',
        });
      }
      events.push(
        {
          title: 'Condition groups changed',
          meta: `${this.rule_condition_count} condition(s), including nested groups, are configured in draft UI`,
          icon: 'bi-diagram-3',
        },
        {
          title: 'Actions modified',
          meta: `${this.enabled_actions_count} enabled action(s) will run when this rule matches`,
          icon: 'bi-lightning-charge',
        },
        {
          title: 'Governance policy checked',
          meta: this.governance_approval_status,
          icon: 'bi-shield-lock',
        }
      );
      return events;
    },
  },
  watch: {
    '$route.query.mode': {
      immediate: true,
      handler() {
        this.sync_view_from_route();
      },
    },
  },
  mounted() {
    this.bootstrap_page();
  },
  methods: {
    parse_response_data(payload) {
      if (typeof payload !== 'string') return payload || {};
      try {
        return JSON.parse(payload);
      } catch {
        return {};
      }
    },
    has_own_value(source, key) {
      return Boolean(source) && Reflect.ownKeys(Object(source)).includes(key);
    },
    get_owned_value(source, key, fallback = undefined) {
      if (!this.has_own_value(source, key)) return fallback;
      return Reflect.get(Object(source), key);
    },
    extract_items(response_data, key) {
      const parsed = this.parse_response_data(response_data);
      const keyed_items = this.get_owned_value(parsed, key, null);
      const items = keyed_items || parsed.data || parsed.results || parsed.questions || [];
      return Array.isArray(items) ? items : [];
    },
    safe_array(value) {
      return Array.isArray(value) ? value : [];
    },
    normalize_question_type_key(value = '') {
      return String(value || '')
        .trim()
        .replace(/([a-z])([A-Z])/g, '$1_$2')
        .replace(/[\s-]+/g, '_')
        .toLowerCase();
    },
    raw_question_type(question_or_type = '') {
      if (question_or_type && typeof question_or_type === 'object') {
        return question_or_type.question_type?.question_type
          || question_or_type.question_type?.type
          || question_or_type.question_type
          || question_or_type.answer_type
          || question_or_type.type
          || '';
      }

      return question_or_type;
    },
    question_type_label(question_or_type = '') {
      const raw_type = this.raw_question_type(question_or_type);
      const normalized_type = this.normalize_question_type_key(raw_type);
      const mapped_label = this.get_owned_value(QUESTION_TYPE_LABELS, normalized_type, null);

      if (mapped_label) return mapped_label;
      if (!raw_type) return 'Question';

      return String(raw_type)
        .trim()
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/\b\w/g, (letter) => letter.toUpperCase());
    },
    onboarding_gate_storage_key() {
      let organization_scope = 'global';
      try {
        const organization = JSON.parse(sessionStorage.getItem('current_organization') || 'null');
        if (organization?.id && organization.external_org_id !== 'ORG-LEGACY') {
          organization_scope = `organization.${organization.id}`;
        }
      } catch {
        // Treat malformed session context as the global scope.
      }
      return `compliance_onboarding_gate:${organization_scope}:${this.route_entity_type_id || 'global'}`;
    },
    default_onboarding_gate() {
      return {
        require_all_assigned: false,
        required_question_ids: [],
        conditional_requirements: [],
      };
    },
    conditional_required_question_ids(requirement = {}) {
      if (Array.isArray(requirement.required_question_ids)) return requirement.required_question_ids.map(String);
      if (requirement.required_question_id) return [String(requirement.required_question_id)];
      return [];
    },
    load_onboarding_gate_config() {
      try {
        const raw = window.localStorage.getItem(this.onboarding_gate_storage_key());
        this.onboarding_gate_by_rule = raw ? JSON.parse(raw) : {};
      } catch {
        this.onboarding_gate_by_rule = {};
      }
    },
    persist_onboarding_gate_config() {
      try {
        window.localStorage.setItem(
          this.onboarding_gate_storage_key(),
          JSON.stringify(this.onboarding_gate_by_rule)
        );
      } catch {
        this.auto_save_status = 'Onboarding gate saved for this session';
      }
    },
    update_onboarding_gate(patch = {}) {
      if (!this.selected_rule_id) return;
      const key = String(this.selected_rule_id);
      this.onboarding_gate_by_rule = {
        ...this.onboarding_gate_by_rule,
        [key]: {
          ...this.default_onboarding_gate(),
          ...this.current_onboarding_gate,
          ...patch,
        },
      };
      this.persist_onboarding_gate_config();
      this.auto_save_status = 'Onboarding gate saved';
    },
    toggle_required_onboarding_question(question) {
      const question_id = this.question_key(question);
      const current_ids = new Set(this.onboarding_required_question_ids);
      if (current_ids.has(question_id)) current_ids.delete(question_id);
      else current_ids.add(question_id);
      this.update_onboarding_gate({
        require_all_assigned: false,
        required_question_ids: [...current_ids],
      });
    },
    add_conditional_onboarding_requirement() {
      const first_question = this.selected_rule_questions[0] || {};
      const second_question = this.selected_rule_questions[1] || first_question;
      const requirement = {
        id: `conditional-${Date.now()}`,
        trigger_question_id: this.question_key(first_question),
        operator: '=',
        trigger_value: 'Yes',
        required_question_ids: [this.question_key(second_question)],
      };
      this.update_onboarding_gate({
        conditional_requirements: [
          ...this.onboarding_conditional_requirements,
          requirement,
        ],
      });
    },
    update_conditional_onboarding_requirement(requirement_id, patch = {}) {
      const normalized_patch = { ...patch };
      if (Object.prototype.hasOwnProperty.call(normalized_patch, 'required_question_ids')) {
        normalized_patch.required_question_ids = this.safe_array(normalized_patch.required_question_ids).map(String);
        normalized_patch.required_question_id = normalized_patch.required_question_ids[0] || '';
      }
      this.update_onboarding_gate({
        conditional_requirements: this.onboarding_conditional_requirements.map((requirement) => (
          requirement.id === requirement_id ? { ...requirement, ...normalized_patch } : requirement
        )),
      });
    },
    remove_conditional_onboarding_requirement(requirement_id) {
      this.update_onboarding_gate({
        conditional_requirements: this.onboarding_conditional_requirements.filter((requirement) => requirement.id !== requirement_id),
      });
    },
    duplicate_conditional_onboarding_requirement(requirement = {}) {
      this.update_onboarding_gate({
        conditional_requirements: [
          ...this.onboarding_conditional_requirements,
          {
            ...requirement,
            id: `conditional-${Date.now()}`,
            required_question_ids: this.conditional_required_question_ids(requirement),
          },
        ],
      });
    },
    question_label_by_id(question_id) {
      const question = this.selected_rule_questions.find((item) => this.question_key(item) === String(question_id));
      return question?.question_text || question?.label || question?.name || `Question ${question_id || ''}`;
    },
    conditional_required_labels(requirement = {}) {
      return this.conditional_required_question_ids(requirement).map((id) => this.question_label_by_id(id)).join(', ') || 'dependent questions';
    },
    conditional_required_summary(requirement = {}) {
      const labels = this.conditional_required_question_ids(requirement).map((id) => this.question_label_by_id(id));
      if (!labels.length) return 'dependent questions';
      if (labels.length === 1) return `"${labels[0]}"`;
      return `${labels.length} questions`;
    },
    answer_options_for_question(question = {}) {
      if (!question) return [];
      const raw_options = [
        question.options,
        question.answer_options,
        question.choices,
        question.choice_options,
        question.question_options,
        question.dropdown_options,
        question.possible_answers,
        question.answers,
        question.question?.options,
        question.question?.answer_options,
      ].find((items) => Array.isArray(items) && items.length);
      if (!raw_options) return [];
      return raw_options.map((option) => {
        if (typeof option === 'string' || typeof option === 'number') return String(option);
        return String(option.label || option.name || option.value || option.option || option.answer || option.text || '').trim();
      }).filter(Boolean);
    },
    normalize_conditional_trigger_value() {
      if (this.conditional_trigger_uses_options) {
        if (!this.conditional_trigger_answer_options.includes(this.conditional_requirement_form.trigger_value)) {
          this.conditional_requirement_form.trigger_value = this.conditional_trigger_answer_options[0] || '';
        }
        this.conditional_requirement_form.operator = '=';
        return;
      }
      if (!['=', 'contains'].includes(this.conditional_requirement_form.operator)) {
        this.conditional_requirement_form.operator = '=';
      }
    },
    set_conditional_trigger_question(question_id) {
      this.conditional_requirement_form.trigger_question_id = String(question_id || '');
      this.conditional_requirement_form.required_question_ids = this.conditional_requirement_form.required_question_ids.filter((id) => String(id) !== String(question_id));
      this.conditional_requirement_form.trigger_value = '';
      this.conditional_requirement_form.operator = '=';
      this.conditional_question_search = this.question_label_by_id(question_id);
      this.conditional_question_picker_open = false;
      this.normalize_conditional_trigger_value();
    },
    close_conditional_question_picker() {
      window.setTimeout(() => {
        this.conditional_question_picker_open = false;
        if (this.conditional_requirement_form.trigger_question_id) {
          this.conditional_question_search = this.question_label_by_id(this.conditional_requirement_form.trigger_question_id);
        }
      }, 120);
    },
    set_conditional_trigger_answer(value) {
      this.conditional_requirement_form.trigger_value = String(value || '');
      this.conditional_requirement_form.operator = '=';
    },
    toggle_conditional_required_question(requirement, question_id) {
      const ids = new Set(this.conditional_required_question_ids(requirement));
      const normalized_id = String(question_id);
      if (ids.has(normalized_id)) ids.delete(normalized_id);
      else ids.add(normalized_id);
      this.update_conditional_onboarding_requirement(requirement.id, { required_question_ids: [...ids] });
    },
    show_bootstrap_modal(modal_id) {
      const modal_element = document.getElementById(modal_id);
      if (!modal_element || !window.bootstrap) return;
      const modal = window.bootstrap.Modal.getOrCreateInstance(modal_element);
      modal.show();
    },
    hide_bootstrap_modal(modal_id) {
      const modal_element = document.getElementById(modal_id);
      if (!modal_element || !window.bootstrap) return;
      const modal = window.bootstrap.Modal.getInstance(modal_element);
      if (modal) modal.hide();
    },
    open_required_questions_modal() {
      this.required_question_modal = {
        search: '',
        form_id: '',
        section: '',
        answer_type: '',
        selected_only: false,
        working_ids: [...this.onboarding_required_question_ids],
        expanded_sections: {},
        visible_limit: 160,
      };
      this.show_bootstrap_modal('required_questions_modal');
    },
    toggle_all_required_modal_questions() {
      if (this.all_assigned_required_questions_selected) this.clear_all_required_questions();
      else this.select_all_assigned_required_questions();
    },
    toggle_required_modal_question(question_id) {
      const ids = new Set(this.required_question_modal.working_ids.map(String));
      const normalized_id = String(question_id);
      if (ids.has(normalized_id)) ids.delete(normalized_id);
      else ids.add(normalized_id);
      this.required_question_modal.working_ids = [...ids];
    },
    toggle_required_modal_section(section_name) {
      this.required_question_modal.expanded_sections = {
        ...this.required_question_modal.expanded_sections,
        [section_name]: this.required_question_modal.expanded_sections[section_name] === false,
      };
    },
    select_all_visible_required_questions() {
      const ids = new Set(this.required_question_modal.working_ids.map(String));
      this.filtered_required_modal_questions.forEach((question) => ids.add(this.question_key(question)));
      this.required_question_modal.working_ids = [...ids];
    },
    clear_visible_required_questions() {
      const visible_ids = new Set(this.filtered_required_modal_questions.map((question) => this.question_key(question)));
      this.required_question_modal.working_ids = this.required_question_modal.working_ids.filter((id) => !visible_ids.has(String(id)));
    },
    select_all_assigned_required_questions() {
      this.required_question_modal.working_ids = this.selected_rule_questions.map((question) => this.question_key(question));
    },
    clear_all_required_questions() {
      this.required_question_modal.working_ids = [];
    },
    load_more_required_modal_questions() {
      this.required_question_modal.visible_limit += 160;
    },
    save_required_questions_modal() {
      const selected_ids = [...new Set(this.required_question_modal.working_ids.map(String))];
      const require_all = selected_ids.length > 0 && selected_ids.length === this.selected_rule_questions.length;
      this.update_onboarding_gate({
        require_all_assigned: require_all,
        required_question_ids: require_all ? [] : selected_ids,
      });
      this.hide_bootstrap_modal('required_questions_modal');
    },
    open_conditional_requirement_modal(requirement = null) {
      const first_question = this.selected_rule_questions[0] || {};
      const second_question = this.selected_rule_questions.find((question) => this.question_key(question) !== this.question_key(first_question)) || {};
      this.conditional_requirement_form = requirement ? {
        id: requirement.id,
        trigger_question_id: String(requirement.trigger_question_id || ''),
        operator: ['=', 'contains'].includes(requirement.operator) ? requirement.operator : '=',
        trigger_value: requirement.trigger_value || '',
        required_question_ids: this.conditional_required_question_ids(requirement).filter((id) => String(id) !== String(requirement.trigger_question_id || '')),
      } : {
        id: null,
        trigger_question_id: this.question_key(first_question),
        operator: '=',
        trigger_value: '',
        required_question_ids: second_question ? [this.question_key(second_question)] : [],
      };
      this.conditional_question_search = this.question_label_by_id(this.conditional_requirement_form.trigger_question_id);
      this.conditional_question_picker_open = false;
      this.normalize_conditional_trigger_value();
      this.show_bootstrap_modal('conditional_requirement_modal');
    },
    toggle_conditional_form_required_question(question_id) {
      const ids = new Set(this.conditional_requirement_form.required_question_ids.map(String));
      const normalized_id = String(question_id);
      if (ids.has(normalized_id)) ids.delete(normalized_id);
      else ids.add(normalized_id);
      this.conditional_requirement_form.required_question_ids = [...ids];
    },
    save_conditional_requirement_modal() {
      const payload = {
        id: this.conditional_requirement_form.id || `conditional-${Date.now()}`,
        trigger_question_id: this.conditional_requirement_form.trigger_question_id,
        operator: this.conditional_requirement_form.operator || '=',
        trigger_value: this.conditional_requirement_form.trigger_value,
        required_question_ids: this.conditional_requirement_form.required_question_ids.map(String),
      };
      const existing = this.onboarding_conditional_requirements.filter((requirement) => requirement.id !== payload.id);
      this.update_onboarding_gate({ conditional_requirements: [...existing, payload] });
      this.hide_bootstrap_modal('conditional_requirement_modal');
    },
    sync_view_from_route() {
      this.current_view = this.$route?.query?.mode === 'builder' ? 'builder' : 'hub';
      if (this.$route?.query?.ruleId) this.selected_rule_id = String(this.$route.query.ruleId);
      if (this.$route?.query?.tab) {
        const requested_tab = String(this.$route.query.tab);
        const normalized_tab = requested_tab === 'testing' ? 'review_publish' : requested_tab;
        this.active_rule_tab = this.rule_tabs.some((step) => step.id === normalized_tab) ? normalized_tab : 'rule_setup';
      }
    },
    days_to_duration(days) {
      if (days === '' || days === null || typeof days === 'undefined') return null;
      const parsed_days = Number(days);
      if (!Number.isFinite(parsed_days) || parsed_days <= 0) return null;
      return `${Math.floor(parsed_days)} 00:00:00`;
    },
    duration_to_days(value) {
      if (!value) return '';
      const text = String(value);
      const day_match = text.match(/^(\d+)\s/);
      if (day_match) return Number(day_match[1]);
      return '';
    },
    format_date(value) {
      if (!value) return 'Not saved yet';
      const parsed_date = new Date(value);
      if (Number.isNaN(parsed_date.getTime())) return 'Not saved yet';
      return new Intl.DateTimeFormat('en-ZA', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).format(parsed_date).replace(',', '');
    },
    creator_label(rule = {}) {
      const creator = rule.creator || {};
      return [
        rule.created_by_name,
        rule.creator_name,
        creator.full_name,
        `${creator.first_name || ''} ${creator.last_name || ''}`.trim(),
        creator.username,
        creator.email,
      ].find((value) => String(value || '').trim()) || 'System admin';
    },
    rule_assignment_forms(rule_id) {
      return this.get_owned_value(this.rule_assignments, String(rule_id), []);
    },
    count_assigned_questions(forms = []) {
      return forms.reduce((form_total, form) => (
        form_total + (form.main_sections || []).reduce((main_total, main) => (
          main_total + (main.sub_sections || []).reduce((sub_total, sub) => (
            sub_total + (sub.questions || []).length
          ), 0)
        ), 0)
      ), 0);
    },
    normalized_form_sections(form_id) {
      const items = this.get_owned_value(this.form_structures, String(form_id), []);
      return (Array.isArray(items) ? items : []).flatMap((main, main_index) => {
        const main_name = main.main_section_name || main.name || main.main_section?.name || `Section ${main_index + 1}`;
        return (main.sub_sections || []).map((sub, sub_index) => {
          const section_name = sub.sub_section_name || sub.section_name || sub.name || sub.section?.name || main_name || `Section ${sub_index + 1}`;
          const collapsed_key = String(sub.sub_section_id || sub.section_id || sub.id || `${main_index}-${sub_index}`);
          return {
            id: sub.sub_section_id || sub.section_id || sub.id || `${main_index}-${sub_index}`,
            main_section_name: main_name,
            section_name,
            collapsed: Boolean(this.get_owned_value(this.collapsed_manual_sections, collapsed_key, false)),
            questions: (sub.questions || []).map((question, question_index) => {
              const nested_question = question.question || {};
              const section_question_id = question.section_question_id || question.id || question.form_section_question_id || question.section_question?.id;
              return {
                ...question,
                id: question.id || section_question_id || `${main_index}-${sub_index}-${question_index}`,
                section_question_id,
                form_id,
                section_name,
                question_text: question.question_text || nested_question.question_text || question.text || `Question ${question_index + 1}`,
                question_type: question.question_type?.question_type || question.question_type || nested_question.question_type?.question_type || nested_question.question_type || 'Text',
                required_label: question.is_mandatory || question.is_required || question.required ? 'Required' : 'Optional',
              };
            }).filter((question) => question.section_question_id),
          };
        });
      });
    },
    total_questions_for_form(form_id) {
      return this.normalized_form_sections(form_id).reduce((total, section) => total + section.questions.length, 0);
    },
    form_updated_label(form_id) {
      const form = this.entity_type_forms.find((item) => String(item.id) === String(form_id));
      return this.format_date(form?.last_updated);
    },
    count_form_questions_used_in_conditions(form_id) {
      return this.selected_rule_questions.filter((question) => String(question.form_id) === String(form_id) && this.is_question_used_in_conditions(question)).length;
    },
    assignment_method_for_form(form = {}) {
      const total = this.total_questions_for_form(form.form_id);
      const assigned = this.count_assigned_questions([form]);
      return total > 0 && assigned >= total ? 'Full Form' : 'Manual Selection';
    },
    form_assignment_display_label(form = {}) {
      return form.assignment_method_label === 'Full Form' ? 'All Questions' : 'Selected Questions';
    },
    assignment_method_for_question(question = {}) {
      const form = this.selected_rule_forms.find((item) => String(item.form_id) === String(question.form_id));
      return form?.assignment_method_label === 'Full Form' ? 'Full Form' : 'Manual';
    },
    question_key(question = {}) {
      return String(question.section_question_id || question.id || '');
    },
    question_reference_ids(question = {}) {
      return [
        question.section_question_id,
        question.id,
        question.compliance_field_id,
        question.field_id,
      ].filter(Boolean).map(String);
    },
    is_question_used_in_conditions(question = {}) {
      return this.question_reference_ids(question).some((id) => this.condition_question_ids.has(id));
    },
    collect_condition_question_ids(groups = []) {
      return groups.flatMap((group) => [
        ...this.collect_group_condition_question_ids(group),
        ...this.collect_condition_question_ids(group.children || []),
      ]);
    },
    collect_group_condition_question_ids(group = {}) {
      return (group.conditions || [])
        .filter((condition) => condition.source_type === 'form_question')
        .flatMap((condition) => this.condition_reference_ids(condition));
    },
    condition_reference_ids(condition = {}) {
      return [
        ...(condition.assigned_question_ids || []),
        condition.assigned_question_id,
        condition.question_id,
        condition.compliance_field_id,
        condition.question_model_id,
        condition.field_id,
      ].filter(Boolean).map(String);
    },
    flatten_condition_rows(groups = []) {
      return groups.flatMap((group) => [
        ...(group.conditions || []),
        ...this.flatten_condition_rows(group.children || []),
      ]);
    },
    condition_operator_requires_value(operator = '=') {
      return !['is empty', 'empty', 'is not empty', 'not_empty', 'not empty'].includes(String(operator || '').trim().toLowerCase());
    },
    condition_has_question_or_field(condition = {}) {
      return Boolean(
        condition.field ||
        condition.assigned_question_id ||
        condition.question_id ||
        condition.compliance_field_id ||
        condition.field_id ||
        condition.question_model_id ||
        (condition.assigned_question_ids || []).length ||
        this.lookup_condition_question(condition)
      );
    },
    condition_row_complete(condition = {}) {
      const has_value = !this.condition_operator_requires_value(condition.operator) || (
        condition.value !== '' &&
        condition.value !== null &&
        condition.value !== undefined
      );
      return this.condition_has_question_or_field(condition) && Boolean(condition.operator) && has_value;
    },
    validation_item: (severity, label) => ({ severity, label }),
    sidebar_rule_setup_validation_items() {
      const items = [];
      if (!this.rule_form.name?.trim()) items.push(this.validation_item('critical', 'Rule name is required.'));
      if (!this.rule_form.logical_operator) items.push(this.validation_item('critical', 'Evaluation logic is not selected.'));
      if (!this.rule_form.trigger_status_id && !this.selected_rule?.trigger_status_label) items.push(this.validation_item('critical', 'Trigger status not selected.'));
      if (Number(this.rule_form.frequency_days) > 0 && Number(this.rule_form.recurring_grace_period_days || 0) < 0) {
        items.push(this.validation_item('warning', 'Recurring grace days must be configured for recurring rules.'));
      }
      if (!Number(this.rule_form.frequency_days || this.selected_rule?.frequency_days)) items.push(this.validation_item('info', 'Recurring compliance is disabled.'));
      return items;
    },
    sidebar_forms_questions_validation_items() {
      const no_forms_or_questions = !this.selected_rule_forms.length && !this.selected_rule_questions.length;
      const forms_without_questions = this.selected_rule_forms.length && !this.selected_rule_questions.length;
      return [
        no_forms_or_questions ? this.validation_item('info', 'Choose an assignment method, then select a form.') : null,
        forms_without_questions ? this.validation_item('warning', 'The selected form has no assigned questions yet.') : null,
      ].filter(Boolean);
    },
    sidebar_onboarding_gate_validation_items() {
      return [
        !this.forms_questions_complete ? this.validation_item('critical', 'Assign forms/questions before configuring the onboarding gate.') : null,
        !this.onboarding_gate_complete ? this.validation_item('critical', 'Select at least one required onboarding question or add an answer-based requirement.') : null,
        this.onboarding_conditional_requirements.length ? this.validation_item('info', `${this.onboarding_conditional_requirements.length} conditional requirement(s) configured.`) : null,
      ].filter(Boolean);
    },
    sidebar_conditions_validation_items() {
      return [
        !this.rule_condition_count ? this.validation_item('critical', 'No evaluation conditions configured.') : null,
        this.rule_condition_count && !this.valid_condition_count ? this.validation_item('critical', 'No complete condition rows configured.') : null,
        this.invalid_condition_count ? this.validation_item('critical', 'One or more saved conditions are incomplete.') : null,
        !this.selected_rule_questions.length ? this.validation_item('warning', 'Assign forms/questions before configuring conditions.') : null,
      ].filter(Boolean);
    },
    sidebar_actions_validation_items() {
      return [
        !this.conditions_complete ? this.validation_item('critical', 'Conditions must be configured before actions.') : null,
        !this.actions_complete ? this.validation_item('critical', 'No action configured for evaluation outcomes.') : null,
      ].filter(Boolean);
    },
    sidebar_ongoing_validation_items() {
      const frequency_days = Number(this.rule_form.frequency_days || this.selected_rule?.frequency_days);
      const grace_days = Number(this.rule_form.recurring_grace_period_days || this.selected_rule?.recurring_grace_period_days);
      return [
        !frequency_days ? this.validation_item('info', 'This rule is onboarding-only.') : null,
        frequency_days > 0 && !grace_days ? this.validation_item('warning', 'Recurring grace days are missing.') : null,
      ].filter(Boolean);
    },
    sidebar_review_publish_validation_items() {
      return [
        ...this.blocking_validation_issues.map((issue) => this.validation_item('critical', issue.label)),
        ...this.warning_validation_issues.map((issue) => this.validation_item('warning', issue.label)),
      ];
    },
    sidebar_validation_items_for_tab(tab) {
      const validators = {
        rule_setup: this.sidebar_rule_setup_validation_items,
        forms_questions: this.sidebar_forms_questions_validation_items,
        onboarding_gate: this.sidebar_onboarding_gate_validation_items,
        conditions: this.sidebar_conditions_validation_items,
        actions: this.sidebar_actions_validation_items,
        ongoing: this.sidebar_ongoing_validation_items,
        review_publish: this.sidebar_review_publish_validation_items,
      };
      const validator = this.get_owned_value(validators, tab, null);
      return validator ? validator.call(this) : [];
    },
    set_assignment_method(method) {
      this.assignment_method = method;
    },
    toggle_manual_section(section) {
      const key = String(section.id);
      const is_collapsed = Boolean(this.get_owned_value(this.collapsed_manual_sections, key, false));
      this.collapsed_manual_sections = {
        ...this.collapsed_manual_sections,
        [key]: !is_collapsed,
      };
    },
    select_all_manual_questions() {
      const ids = new Set(this.manual_selected_question_ids);
      this.manual_visible_question_ids.forEach((id) => {
        ids.add(String(id));
      });
      this.manual_selected_question_ids = [...ids];
    },
    clear_manual_questions() {
      const visible_ids = new Set(this.manual_visible_question_ids.map(String));
      this.manual_selected_question_ids = this.manual_selected_question_ids.filter((id) => !visible_ids.has(String(id)));
    },
    toggle_all_manual_questions() {
      if (this.all_manual_visible_selected) this.clear_manual_questions();
      else this.select_all_manual_questions();
    },
    async load_form_structure(form_id) {
      if (!form_id) return [];
      const key = String(form_id);
      const cached_structure = this.get_owned_value(this.form_structures, key, null);
      if (cached_structure) return cached_structure;
      const response = await axios.get(GET_FORM_STRUCTURE_URL, get_request_config({ params: { form_id } }));
      const items = this.extract_items(response.data, 'data');
      this.form_structures = {
        ...this.form_structures,
        [key]: items,
      };
      return items;
    },
    async load_manual_form_questions() {
      if (!this.manual_form_id) return;
      this.loading_manual_questions = true;
      try {
        await this.load_form_structure(this.manual_form_id);
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to load questions for this form.');
      } finally {
        this.loading_manual_questions = false;
      }
    },
    assigned_questions_for_form(form_id) {
      return this.selected_rule_questions.filter((question) => String(question.form_id) === String(form_id));
    },
    assigned_question_names_for_form(form) {
      return this.assigned_questions_for_form(form.form_id).map((question) => question.question_text).filter(Boolean);
    },
    assigned_questions_by_section_for_form(form) {
      const sections = new Map();
      this.assigned_questions_for_form(form.form_id).forEach((question) => {
        const section_name = question.section_name || 'Section';
        sections.set(section_name, (sections.get(section_name) || 0) + 1);
      });
      return [...sections.entries()].map(([section_name, count]) => ({ section_name, count }));
    },
    async open_assignment_questions_modal(form_id = this.selected_form_id, options = {}) {
      if (!this.selected_rule_id) {
        this.show_error('Select a compliance rule before assigning forms.');
        return;
      }
      if (!form_id) {
        this.show_error('Select a form first.');
        return;
      }
      this.loading_manual_questions = true;
      try {
        await this.load_form_structure(form_id);
        const existing_questions = this.assigned_questions_for_form(form_id);
        const existing_ids = existing_questions.map((question) => String(question.section_question_id || question.id)).filter(Boolean);
        const all_question_ids = this.normalized_form_sections(form_id)
          .flatMap((section) => section.questions.map((question) => String(question.section_question_id)));
        const default_method = existing_ids.length && existing_ids.length < all_question_ids.length ? 'manual' : 'full_form';
        const method = options.method || default_method;
        this.assignment_question_modal = {
          form_id: String(form_id),
          method,
          question_search: '',
          section_filter: options.section_filter || '',
          answer_type_filter: '',
          selected_only: Boolean(options.selected_only),
          selected_question_ids: method === 'full_form' ? all_question_ids : existing_ids,
          select_all_questions: method === 'full_form',
          expanded_sections: this.normalized_form_sections(form_id).reduce((acc, section, index) => ({
            ...acc,
            [String(section.id || section.section_name)]: index === 0,
          }), {}),
          visible_limit: 120,
        };
        const modal = window.bootstrap.Modal.getOrCreateInstance(document.getElementById('assignment_questions_modal'));
        modal.show();
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to load questions for this form.');
      } finally {
        this.loading_manual_questions = false;
      }
    },
    async add_selected_form_to_rule() {
      if (!this.selected_rule_id) {
        this.show_error('Select a compliance rule before assigning forms.');
        return;
      }
      if (!this.selected_form_id) {
        this.show_error('Select a form first.');
        return;
      }
        if (!this.selected_form_is_available) {
          this.show_info('This form is no longer available.');
          return;
        }
      await this.assign_selected_form_to_rule({ reset_selection: true });
    },
    open_configure_form_questions(form) {
      this.open_assignment_questions_modal(form.form_id, {
        method: form.assignment_method_label === 'Full Form' ? 'full_form' : 'manual',
      });
    },
    open_manage_form_questions_selected_only(form) {
      this.open_assignment_questions_modal(form.form_id, {
        method: form.assignment_method_label === 'Full Form' ? 'full_form' : 'manual',
        selected_only: true,
      });
    },
    close_assignment_questions_modal() {
      this.close_modal('assignment_questions_modal');
    },
    set_assignment_modal_method(method) {
      this.assignment_question_modal.method = method;
      if (method === 'full_form') {
        this.set_assignment_modal_select_all(true);
      }
    },
    set_assignment_modal_select_all(checked) {
      this.assignment_question_modal.select_all_questions = checked;
      this.assignment_question_modal.selected_question_ids = checked
        ? this.assignment_modal_form_questions.map((question) => String(question.section_question_id))
        : [];
    },
    select_all_assignment_modal_questions() {
      const ids = new Set(this.assignment_question_modal.selected_question_ids.map(String));
      this.filtered_assignment_modal_questions.forEach((question) => {
        ids.add(String(question.section_question_id));
      });
      this.assignment_question_modal.selected_question_ids = [...ids];
    },
    filtered_assignment_modal_question_ids() {
      const search = String(this.assignment_question_modal.question_search || '').trim().toLowerCase();
      const selected_ids = new Set(this.assignment_question_modal.selected_question_ids.map(String));
      const section_filter = String(this.assignment_question_modal.section_filter || '');
      const answer_type_filter = String(this.assignment_question_modal.answer_type_filter || '');
      return this.assignment_modal_form_questions.filter((question) => {
        const question_type = String(this.raw_question_type(question) || '');
        return (!search || [
          question.question_text,
          question.section_name,
          question_type,
          this.question_type_label(question_type),
        ].join(' ').toLowerCase().includes(search)) &&
          (!section_filter || String(question.section_name || '') === section_filter) &&
          (!answer_type_filter || question_type === answer_type_filter) &&
          (!this.assignment_question_modal.selected_only || selected_ids.has(String(question.section_question_id)));
      }).map((question) => String(question.section_question_id));
    },
    select_all_filtered_assignment_questions() {
      const ids = new Set(this.assignment_question_modal.selected_question_ids.map(String));
      this.filtered_assignment_modal_question_ids().forEach((id) => ids.add(id));
      this.assignment_question_modal.selected_question_ids = [...ids];
    },
    clear_assignment_modal_questions() {
      const visible_ids = new Set(this.filtered_assignment_modal_questions.map((question) => String(question.section_question_id)));
      this.assignment_question_modal.selected_question_ids = this.assignment_question_modal.selected_question_ids.filter((id) => !visible_ids.has(String(id)));
    },
    clear_assignment_modal_section(section_name) {
      const section_ids = new Set(this.assignment_modal_form_questions
        .filter((question) => String(question.section_name || '') === String(section_name || ''))
        .map((question) => String(question.section_question_id)));
      this.assignment_question_modal.selected_question_ids = this.assignment_question_modal.selected_question_ids.filter((id) => !section_ids.has(String(id)));
    },
    select_assignment_modal_section(section_name) {
      const ids = new Set(this.assignment_question_modal.selected_question_ids.map(String));
      this.assignment_modal_form_questions
        .filter((question) => String(question.section_name || '') === String(section_name || ''))
        .forEach((question) => ids.add(String(question.section_question_id)));
      this.assignment_question_modal.selected_question_ids = [...ids];
    },
    clear_assignment_modal_filters() {
      this.assignment_question_modal.question_search = '';
      this.assignment_question_modal.section_filter = '';
      this.assignment_question_modal.answer_type_filter = '';
      this.assignment_question_modal.selected_only = false;
      this.assignment_question_modal.visible_limit = 120;
    },
    toggle_assignment_modal_section(section) {
      const key = String(section.id || section.section_name);
      this.assignment_question_modal.expanded_sections = {
        ...this.assignment_question_modal.expanded_sections,
        [key]: !this.assignment_modal_section_expanded(section),
      };
    },
    assignment_modal_section_expanded(section) {
      const key = String(section.id || section.section_name);
      return this.assignment_question_modal.expanded_sections[key] !== false;
    },
    load_more_assignment_modal_questions() {
      this.assignment_question_modal.visible_limit += 120;
    },
    extract_section_names(form = {}) {
      const names = [];
      (form.main_sections || []).forEach((main) => {
        if (main.main_section_name) names.push(main.main_section_name);
        (main.sub_sections || []).forEach((sub) => {
          if (sub.sub_section_name) names.push(sub.sub_section_name);
        });
      });
      return [...new Set(names)].filter(Boolean);
    },
    flatten_assignment_forms(forms = [], rule = null) {
      return forms.flatMap((form) => this.flatten_assignment_form(form, rule));
    },
    flatten_assignment_form(form = {}, rule = null) {
      return (form.main_sections || []).flatMap((main) => (
        (main.sub_sections || []).flatMap((sub) => (
          (sub.questions || []).map((question) => this.assignment_question_row(question, form, main, sub, rule))
        ))
      ));
    },
    assignment_question_row(question = {}, form = {}, main = {}, sub = {}, rule = null) {
      return {
        ...question,
        rule_id: rule?.id,
        rule_name: rule?.name || 'Compliance Rule',
        form_id: form.form_id,
        form_name: form.form_name,
        section_name: sub.sub_section_name || main.main_section_name || 'Section',
        question_type: question.question_type || question.type || 'Text',
        required_label: question.is_required || question.required ? 'Required' : 'Optional',
        compliance_field_label: question.compliance_field_id ? `Field ${question.compliance_field_id}` : 'Not available',
        mapping_status: question.compliance_field_id ? 'Mapped' : 'Assigned',
        assignment_method_label: this.assignment_method_for_form(form) === 'Full Form' ? 'Full Form' : 'Manual',
      };
    },
    normalize_rule(rule = {}) {
      const assignments = this.rule_assignment_forms(rule.id);
      const trigger_status = Array.isArray(rule.trigger_statuses) && rule.trigger_statuses.length ? rule.trigger_statuses[0] : null;
      const assigned_questions_count = this.count_assigned_questions(assignments);
      const assigned_forms_count = assignments.length;
      const frequency_days = rule.frequency_days || this.duration_to_days(rule.frequency);
      const initial_grace_period_days = rule.initial_grace_period_days || this.duration_to_days(rule.initial_grace_period) || 7;
      const recurring_grace_period_days = rule.recurring_grace_period_days || this.duration_to_days(rule.recurring_grace_period);
      const status = trigger_status ? 'Active' : 'Draft';
      let health_status = 'Healthy';
      if (!assigned_forms_count) health_status = 'Needs Forms';
      if (!assigned_questions_count) health_status = 'Needs Questions';
      if (!trigger_status) health_status = 'Missing Trigger';

      return {
        ...rule,
        logic: rule.logical_operator || 'AND',
        status,
        health_status,
        trigger_status_id: trigger_status?.id ? String(trigger_status.id) : '',
        trigger_status_label: trigger_status?.status || '',
        initial_grace_period_days,
        frequency_days,
        recurring_grace_period_days,
        assigned_forms_count,
        assigned_questions_count,
        created_by: this.creator_label(rule),
        updated_label: this.format_date(rule.date_updated || rule.updated_at || rule.date_created),
        updated_sort: new Date(rule.date_updated || rule.updated_at || rule.date_created || 0).getTime() || 0,
        rule_mode: Number(frequency_days) > 0 ? 'Ongoing' : 'Onboarding',
      };
    },
    health_badge_class(value) {
      if (value === 'Healthy' || value === 'Configured') return 'bg-success-subtle text-success';
      if (value === 'Missing Trigger') return 'bg-danger-subtle text-danger';
      return 'bg-warning-subtle text-dark';
    },
    status_badge_class(value) {
      if (value === 'Active') return 'workflow-status-active';
      if (value === 'Inactive' || value === 'Archived') return 'workflow-status-archived';
      return 'workflow-status-pending';
    },
    validation_badge_class(check) {
      if (check.ok) return 'bg-success-subtle text-success';
      if (check.severity === 'critical') return 'bg-danger-subtle text-danger';
      return 'bg-warning-subtle text-dark';
    },
    step_badge_class(status) {
      if (status === 'Complete') return 'compliance-complete-badge';
      if (status === 'Needs Attention') return 'bg-warning-subtle text-dark';
      if (status === 'In Progress') return 'bg-primary-subtle text-primary';
      if (status === 'Locked') return 'bg-light text-secondary border';
      return 'bg-light text-dark border';
    },
    step_icon_class(step) {
      if (!step.unlocked) return 'bi-lock';
      if (step.complete) return 'bi-check-circle-fill';
      if (step.status === 'Needs Attention') return 'bi-exclamation-circle';
      return step.icon || 'bi-circle';
    },
    is_step_unlocked(step_id) {
      const order = ['rule_setup', 'forms_questions', 'onboarding_gate', 'conditions', 'actions', 'ongoing', 'review_publish'];
      const index = order.indexOf(step_id);
      if (index === -1) return false;
      if (index <= 0) return true;
      if (step_id === 'forms_questions') return this.rule_setup_complete;
      if (step_id === 'onboarding_gate') return this.rule_setup_complete && this.forms_questions_complete;
      if (step_id === 'conditions') return this.rule_setup_complete && this.forms_questions_complete && this.onboarding_gate_complete;
      if (step_id === 'actions') return this.rule_setup_complete && this.forms_questions_complete && this.onboarding_gate_complete && this.conditions_complete;
      if (step_id === 'ongoing') return this.rule_setup_complete && this.forms_questions_complete && this.onboarding_gate_complete && this.conditions_complete && this.actions_complete;
      if (step_id === 'review_publish') return this.rule_setup_complete && this.forms_questions_complete && this.onboarding_gate_complete && this.conditions_complete && this.actions_complete && this.ongoing_complete;
      return false;
    },
    get_condition_operators(condition = {}) {
      const type = this.normalized_condition_type(condition);
      return this.get_owned_value(this.question_type_operators, type, null) || this.available_condition_operators;
    },
    questions_for_condition(condition = {}) {
      if (!condition.form_id) return [];
      return this.selected_rule_questions.filter((question) => {
        const form_matches = String(question.form_id) === String(condition.form_id);
        const section_matches = !condition.section_name || question.section_name === condition.section_name;
        return form_matches && section_matches;
      });
    },
    selected_form_has_condition_questions(condition = {}) {
      return Boolean(condition.form_id) && this.questions_for_condition(condition).length > 0;
    },
    sections_for_form(form_id) {
      return [...new Set(this.selected_rule_questions.filter((question) => String(question.form_id) === String(form_id)).map((question) => question.section_name).filter(Boolean))];
    },
    lookup_condition_question(condition = {}) {
      const selected_id = String(condition.assigned_question_id || "");

      if (!selected_id) {
        return null;
      }

      return this.selected_rule_questions.find(
        question =>
          String(question.section_question_id || question.id) === selected_id
      ) || null;
    },
    condition_question_ids_for_form(condition = {}) {
      return this.questions_for_condition(condition).map((question) => String(question.section_question_id || question.id));
    },
    condition_selected_question_ids(condition = {}) {
      if (Array.isArray(condition.assigned_question_ids)) return condition.assigned_question_ids.map(String);
      return condition.assigned_question_id ? [String(condition.assigned_question_id)] : [];
    },
    all_condition_questions_selected(condition = {}) {
      const available_ids = this.condition_question_ids_for_form(condition);
      const selected_ids = new Set(this.condition_selected_question_ids(condition));
      return available_ids.length > 0 && available_ids.every((id) => selected_ids.has(id));
    },
    condition_question_picker_label(condition = {}) {
      const selected_count = this.condition_selected_question_ids(condition).length;
      if (!condition.form_id) return 'Select assigned form first';
      if (!this.selected_form_has_condition_questions(condition)) return 'No configured questions for this form';
      if (!selected_count) return 'Select assigned questions';
      if (selected_count === 1) {
        const question = this.lookup_condition_question(condition);
        return question?.question_text || '1 question selected';
      }
      return `${selected_count} questions selected`;
    },
    backend_condition_type_id() {
      const types = this.compliance_dropdowns.condition_types || [];
      const preferred = types.find((type) => String(type.name || '').toLowerCase().includes('question'));
      return preferred?.id || types[0]?.id || null;
    },
    backend_condition_operator_id(operator = '=') {
      const operators = this.compliance_dropdowns.operators || [];
      const normalized = String(operator || '=').trim().toLowerCase();
      const aliases = {
        '=': 'equals',
        '==': 'equals',
        equals: 'equals',
        equal: 'equals',
        '!=': 'not_equals',
        '<>': 'not_equals',
        '>': 'greater_than',
        '<': 'less_than',
        '>=': 'greater_or_equal',
        '<=': 'less_or_equal',
        'is not empty': 'not_empty',
        'is empty': 'empty',
      };
      const target = this.get_owned_value(aliases, normalized, normalized);
      const match = operators.find((item) => {
        const value = String(item.operator || '').trim().toLowerCase();
        return value === target || value === normalized;
      });
      return match?.id || operators[0]?.id || null;
    },
    question_model_id_for_condition(condition = {}) {
      const question = this.lookup_condition_question(condition);
      return Number(question?.question_id || question?.question?.id || question?.id || condition.question_model_id || 0);
    },
    normalized_condition_type(condition = {}) {
      const raw_type = String(condition.question_type || this.lookup_condition_question(condition)?.question_type || 'Text').trim();
      const lower_type = raw_type.toLowerCase().replace(/\s+/g, '_');
      if (lower_type.includes('number') || lower_type.includes('integer') || lower_type.includes('decimal')) return 'number';
      if (lower_type.includes('date')) return 'date';
      if (lower_type.includes('boolean') || lower_type.includes('yes') || lower_type.includes('no')) return 'boolean';
      if (lower_type.includes('short_text')) return 'short_text';
      if (lower_type.includes('long_text') || lower_type.includes('textarea')) return 'long_text';
      return raw_type;
    },
    condition_value_input_type(condition = {}) {
      const type = this.normalized_condition_type(condition);
      if (type === 'number') return 'number';
      if (type === 'date') return 'date';
      return 'text';
    },
    is_boolean_condition(condition = {}) {
      return this.normalized_condition_type(condition) === 'boolean';
    },
    condition_row_invalid(condition = {}, field) {
      if (!this.condition_group_form.show_validation) return false;
      if (field === 'form_id') return !condition.form_id;
      if (field === 'question_id') return !this.condition_selected_question_ids(condition).length && !condition.question_id;
      if (field === 'operator') return !condition.operator;
      if (field === 'value') {
        if (!this.condition_operator_requires_value(condition.operator)) return false;
        return condition.value === '' || condition.value === null || condition.value === undefined;
      }
      return false;
    },
    update_condition_form(condition) {
      condition.assigned_question_id = '';
      condition.assigned_question_ids = [];
      condition.compliance_field_id = '';
      condition.question_id = '';
      condition.section_name = '';
      condition.question_type = 'Text';
      condition.field = '';
      condition.operator = '=';
      condition.value = '';
    },
    condition_group_name(group = {}, index = 0) {
      return group.name || `Group ${index + 1}`;
    },
     
    condition_count_for_group(group = {}) {
      return (group.conditions || []).length;
    },
    condition_summary_lines(group = {}) {
      const lines = (group.conditions || []).map((condition) => this.condition_summary_line(condition));
      return lines.length ? lines : ['No condition rows configured yet.'];
    },
    condition_summary_line(condition = {}) {
      const question = this.lookup_condition_question(condition) || {};
      const matched_form = this.selected_rule_forms.find((form) => String(form.form_id) === String(condition.form_id));
      const form_name = question.form_name || matched_form?.form_name || 'Assigned form';
      const question_label = question.question_text || condition.field || 'Assigned question';
      const operator = condition.operator || '=';
      const value = condition.value || 'value';
      return `${form_name} -> ${question_label} ${operator} ${value}`;
    },
    condition_table_rows(group = {}) {
      return (group.conditions || []).map((condition, index) => {
        const question = this.lookup_condition_question(condition) || {};
        return {
          number: index + 1,
          question: question.question_text || condition.field || 'Assigned question',
          section: question.section_name || condition.section_name || '',
          operator: condition.operator || '=',
          value: condition.value || 'value',
        };
      });
    },
    condition_preview_sentence(group = {}) {
      const lines = this.condition_table_rows(group).map((row) => (
        `${row.question} ${row.operator} "${row.value}"`
      ));
      if (!lines.length) return 'No condition rows configured yet.';
      return `IF ${lines.join(` ${group.logic || 'AND'} `)} THEN execute compliance actions and write an audit trail.`;
    },
    reset_condition_group_form() {
      this.condition_group_form = {
        id: null,
        mode: 'create',
        name: `Group ${this.condition_groups.length + 1}`,
        logic: 'AND',
        show_validation: false,
        conditions: [this.create_condition_row()],
      };
    },
    create_condition_row(overrides = {}) {
      return {
        id: Date.now() + Math.floor(Math.random() * 1000),
        source_type: 'form_question',
        form_id: '',
        assigned_question_id: '',
        assigned_question_ids: [],
        compliance_field_id: '',
        section_name: '',
        question_id: '',
        question_type: 'Text',
        field: '',
        operator: '=',
        value: '',
        ...overrides,
      };
    },
    clean_condition_for_selected_question(condition = {}, selected_id = '') {
      const question = this.lookup_condition_question({ ...condition, assigned_question_id: selected_id });
      const assigned_question_id = this.assigned_question_id_for_clean_condition(condition, question, selected_id);
      return {
    ...condition,

    // Preserve the database IDs
    backend_condition_id: condition.backend_condition_id ?? null,
    version: condition.version ?? 1,

    source_type: 'form_question',
    form_id: String(condition.form_id || question?.form_id || ''),
    assigned_question_id,
    assigned_question_ids: [assigned_question_id],
    compliance_field_id: this.compliance_field_id_for_clean_condition(
        condition,
        question,
        assigned_question_id
    ),
    question_id: assigned_question_id,
    section_name: question?.section_name || condition.section_name || '',
    question_type: question?.question_type || condition.question_type || 'Text',
    field: question?.question_text || question?.compliance_field_label || condition.field || '',
};
    },
    assigned_question_id_for_clean_condition(condition = {}, question = null, selected_id = '') {
      if (question) return String(question.section_question_id || question.id || '');
      return String(selected_id || condition.question_id || '');
    },
    compliance_field_id_for_clean_condition(condition = {}, question = null, assigned_question_id = '') {
      return String(question?.compliance_field_id || question?.field_id || condition.compliance_field_id || assigned_question_id);
    },
    open_condition_group_modal(group = null) {
      if (!this.selected_rule_questions.length) {
        this.reset_condition_group_form();
      } else if (group) {
        this.condition_group_form = {
          id: group.id,
          mode: 'edit',
          name: group.name || this.condition_group_name(group, this.condition_groups.findIndex((item) => item.id === group.id)),
          logic: group.logic || 'AND',
          show_validation: false,
          conditions: (group.conditions || []).map((condition) => ({
            ...condition,
            assigned_question_id: condition.assigned_question_id || condition.question_id || condition.compliance_field_id || '',
            assigned_question_ids: condition.assigned_question_ids?.length
              ? condition.assigned_question_ids.map(String)
              : [condition.assigned_question_id || condition.question_id || condition.compliance_field_id].filter(Boolean).map(String),
            question_id: condition.question_id || condition.assigned_question_id || condition.compliance_field_id || '',
          })),
        };
        if (!this.condition_group_form.conditions.length) this.condition_group_form.conditions.push(this.create_condition_row());
      } else {
        this.reset_condition_group_form();
      }
      const modal = new window.bootstrap.Modal(document.getElementById('condition_group_modal'));
      modal.show();
    },
    add_condition_group_row() {
      this.condition_group_form.conditions.push(this.create_condition_row());
    },
   async remove_condition_group_row(condition_id) {
    try {
        
        const condition = this.condition_group_form.conditions.find(
            condition => condition.id === condition_id
        );

        if (!condition) return;

    
        if (condition.backend_condition_id) {
            await axios.post(
                DELETE_COMPLIANCE_CONDITION_URL,
                {
                    id: condition.backend_condition_id
                },
                get_request_config()
            );
        }

        this.condition_group_form.conditions =
            this.condition_group_form.conditions.filter(
                condition => condition.id !== condition_id
            );

      
        await this.fetch_rule_conditions(this.selected_rule_id);

        this.show_success("Condition removed successfully.");

    } catch (error) {
        const response_data = this.parse_response_data(
            error?.response?.data || {}
        );

        this.show_error(
            response_data.message ||
            "Failed to remove condition."
        );
    }

    },
    async save_condition_group_modal() {
      if (!this.selected_rule_questions.length) {
        this.show_warning('Assign forms/questions before creating conditions.');
        return;
      }
      this.condition_group_form.show_validation = true;
      const invalid = this.condition_group_form.conditions.some((condition) => {
        const missing_value = this.condition_operator_requires_value(condition.operator) && (
          condition.value === '' ||
          condition.value === null ||
          condition.value === undefined
        );
        return (
          !condition.form_id ||
          (!this.condition_selected_question_ids(condition).length && !condition.question_id) ||
          !condition.operator ||
          missing_value
        );
      });
      if (invalid) {
        this.show_warning('Complete the form, question, operator, and any required comparison value for each condition row.');
        return;
      }
      const clean_conditions = this.condition_group_form.conditions
        .flatMap((condition) => this.condition_selected_question_ids(condition).map((selected_id) => (
          this.clean_condition_for_selected_question(condition, selected_id)
        )));
      if (!clean_conditions.length) {
        this.show_warning('Select at least one assigned question before saving this condition group.');
        return;
      }
      if (!this.compliance_dropdowns.condition_types.length || !this.compliance_dropdowns.operators.length) {
        await this.fetch_compliance_dropdowns();
      }
      const condition_type_id = this.backend_condition_type_id();
      if (!condition_type_id) {
        this.show_warning('Condition setup data is missing. Ask an admin to run the condition type/operator seed commands for this tenant.');
        return;
      }
      const loader = await this.show_loader('Saving condition group...');
      const payload = {
        id: this.condition_group_form.id || Date.now(),
        compliance_rule_id: Number(this.selected_rule_id),
        group_name: this.condition_group_form.name || `Group ${this.condition_groups.length + 1}`,
        group_logic: this.condition_group_form.logic || 'AND',
        name: this.condition_group_form.name || `Group ${this.condition_groups.length + 1}`,
        logic: this.condition_group_form.logic || 'AND',
        collapsed: true,
        children: [],
        conditions: clean_conditions,
      };
      try {
        const saved_conditions = [];
        for (const condition of clean_conditions) {
          const condition_operator_id = this.backend_condition_operator_id(condition.operator);
          if (!condition_operator_id) throw new Error('Condition operator dropdown data is missing.');
          const conditionValue = this.condition_operator_requires_value(condition.operator)
            ? String(condition.value ?? '')
            : '';

          const condition_response = await axios.post(
            CREATE_COMPLIANCE_CONDITION_URL,
            {
              compliance_rule: Number(this.selected_rule_id),
              condition_type: condition_type_id,
              condition_operator: condition_operator_id,
              value: conditionValue,
              selected_options: [{
                group_name: payload.name,
                group_logic: payload.logic,
                form_id: condition.form_id,
                section_question_id: condition.assigned_question_id,
                question_text: condition.field,
                operator: condition.operator,
                value: conditionValue,
              }],
              version: 1,
            },
            get_request_config()
          );
          const response_data = this.parse_response_data(condition_response.data);
          const backend_condition_id = response_data.condition_id || response_data.condition?.id;
          if (backend_condition_id) {
            const question_model_id = this.question_model_id_for_condition(condition);
            if (question_model_id) {
              await axios.post(
                ASSIGN_QUESTION_TO_CONDITION_URL,
                {
                  condition_id: Number(backend_condition_id),
                  question_id: question_model_id,
                  selected_options: [{
                    section_question_id: condition.assigned_question_id,
                    id: condition.assigned_question_id,
                    label: String(conditionValue || condition.field || 'Selected condition value'),
                    operator: condition.operator,
                    value: conditionValue,
                  }],
                },
                get_request_config()
              );
            }
            saved_conditions.push({ ...condition, backend_condition_id });
          }
        }
        const saved_payload = { ...payload, conditions: saved_conditions.length ? saved_conditions : clean_conditions };
        if (this.condition_group_form.mode === 'edit') {
          this.condition_groups = this.condition_groups.map((group) => (group.id === saved_payload.id ? saved_payload : group));
        } else {
          this.condition_groups.push(saved_payload);
        }
        await this.fetch_rule_conditions(this.selected_rule_id);
        const modal = window.bootstrap.Modal.getInstance(document.getElementById('condition_group_modal'));
        if (modal) modal.hide();
        this.show_success('Condition group saved.');
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || error?.message || 'Failed to save condition group.');
      } finally {
        await this.close_loader(loader);
      }
    },

    async update_condition_group_modal() {
      if (!this.selected_rule_questions.length) {
        this.show_warning('Assign forms/questions before creating conditions.');
        return;
      }
      this.condition_group_form.show_validation = true;
      const invalid = this.condition_group_form.conditions.some((condition) => {
        const missing_value = this.condition_operator_requires_value(condition.operator) && (
          condition.value === '' ||
          condition.value === null ||
          condition.value === undefined
        );
        return (
          !condition.form_id ||
          (!this.condition_selected_question_ids(condition).length && !condition.question_id) ||
          !condition.operator ||
          missing_value
        );
      });
      if (invalid) {
        this.show_warning('Complete the form, question, operator, and any required comparison value for each condition row.');
        return;
      }
      const clean_conditions = this.condition_group_form.conditions
        .flatMap((condition) => this.condition_selected_question_ids(condition).map((selected_id) => (
          this.clean_condition_for_selected_question(condition, selected_id)
        )));
      if (!clean_conditions.length) {
        this.show_warning('Select at least one assigned question before saving this condition group.');
        return;
      }
      if (!this.compliance_dropdowns.condition_types.length || !this.compliance_dropdowns.operators.length) {
        await this.fetch_compliance_dropdowns();
      }
      const condition_type_id = this.backend_condition_type_id();
      if (!condition_type_id) {
        this.show_warning('Condition setup data is missing. Ask an admin to run the condition type/operator seed commands for this tenant.');
        return;
      }
      const loader = await this.show_loader('Saving condition group...');
      const payload = {
        id: this.condition_group_form.id || Date.now(),
        compliance_rule_id: Number(this.selected_rule_id),
        group_name: this.condition_group_form.name || `Group ${this.condition_groups.length + 1}`,
        group_logic: this.condition_group_form.logic || 'AND',
        name: this.condition_group_form.name || `Group ${this.condition_groups.length + 1}`,
        logic: this.condition_group_form.logic || 'AND',
        collapsed: true,
        children: [],
        conditions: clean_conditions,
      };
      try {
    const saved_conditions = [];

    for (const condition of clean_conditions) {

        const condition_operator_id = this.backend_condition_operator_id(condition.operator);

        if (!condition_operator_id) {
            throw new Error("Condition operator dropdown data is missing.");
        }

        const conditionValue = this.condition_operator_requires_value(condition.operator)
            ? String(condition.value ?? "")
            : "";

      
      await axios.post(
      UPDATE_COMPLIANCE_CONDITION_URL,
      {
        id: condition.backend_condition_id, // Existing record ID

        compliance_rule: Number(this.selected_rule_id),
        condition_type: condition_type_id,
        condition_operator: condition_operator_id,
        value: conditionValue,

        selected_options: [{
            group_name: payload.name,
            group_logic: payload.logic,
            form_id: condition.form_id,
            section_question_id: condition.assigned_question_id,
            question_text: condition.field,
            operator: condition.operator,
            value: conditionValue,
        }],

       version: condition.version ?? 1,
    },
    get_request_config()
    );

       saved_conditions.push({
    ...condition,
    backend_condition_id: condition.backend_condition_id,
});
    }

    const saved_payload = {
        ...payload,
        conditions: saved_conditions,
    };

    this.condition_groups = this.condition_groups.map(group =>
        group.id === payload.id
            ? saved_payload
            : group
    );

    await this.fetch_rule_conditions(this.selected_rule_id);

    const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("condition_group_modal")
    );

    if (modal) {
        modal.hide();
    }

    this.show_success("Condition group updated successfully.");
}
     catch (error) {
    const response_data = this.parse_response_data(
        error?.response?.data || {}
    );

    this.show_error(
        response_data.message ||
        error.message ||
        "Failed to update condition group."
    );
  }
     finally {
    await this.close_loader(loader);
  }
    },
    duplicate_condition_group(group) {
      if (!group) return;
      this.condition_groups.push({
        ...group,
        id: Date.now(),
        name: `${group.name || 'Group'} Copy`,
        conditions: (group.conditions || []).map((condition) => ({ ...condition, id: Date.now() + Math.floor(Math.random() * 1000) })),
        children: [],
      });
    },
    async delete_condition_group(group_id) {
    const group = this.condition_groups.find(group => group.id === group_id);

      if (!group) return;

  try {
    for (const condition of group.conditions) {

      if (condition.backend_condition_id) {
        await axios.post(
          DELETE_COMPLIANCE_CONDITION_URL,
          {
            id: condition.backend_condition_id,
          },
          get_request_config()
        );
      }

    }

    this.condition_groups = this.condition_groups.filter(
      group => group.id !== group_id
    );

    await this.fetch_rule_conditions(this.selected_rule_id);

    this.show_success("Condition deleted successfully.");

  } catch (error) {
    this.show_error("Failed to delete condition.");
  }
},
    update_condition_question(condition) {
      const selected_ids = this.condition_selected_question_ids(condition);
      const first_selected_id = selected_ids[0] || '';
      if (!first_selected_id) {
        condition.assigned_question_id = first_selected_id;
        condition.question_id = '';
        condition.compliance_field_id = '';
        condition.section_name = '';
        condition.question_type = 'Text';
        condition.field = '';
        return;
      }
      const question = this.lookup_condition_question({ ...condition, assigned_question_id: first_selected_id });
      if (!question) return;
      const assigned_question_id = String(question.section_question_id || question.id || '');
      condition.assigned_question_id = assigned_question_id;
      condition.assigned_question_ids = selected_ids;
      condition.question_id = assigned_question_id;
      condition.compliance_field_id = String(question.compliance_field_id || question.field_id || assigned_question_id);
      condition.form_id = String(question.form_id || condition.form_id || '');
      condition.question_type = question.question_type || 'Text';
      condition.field = question.question_text || question.compliance_field_label || '';
      const operators = this.get_condition_operators(condition);
      if (!operators.includes(condition.operator)) condition.operator = operators[0] || '=';
      this.selected_preview_question_id = String(question.id || question.section_question_id || '');
    },
    toggle_all_condition_questions(condition) {
      const all_ids = this.condition_question_ids_for_form(condition);
      condition.assigned_question_ids = this.all_condition_questions_selected(condition) ? [] : all_ids;
      condition.assigned_question_id = condition.assigned_question_ids[0] || '';
      if (condition.assigned_question_id) {
        this.update_condition_question(condition);
      } else {
        condition.question_id = '';
        condition.compliance_field_id = '';
        condition.section_name = '';
        condition.question_type = 'Text';
        condition.field = '';
      }
    },
    update_condition_entity_field(condition) {
      const field = this.source_fields.find((item) => item.source === condition.entity_source && item.field === condition.field);
      if (!field) return;
      condition.question_type = field.type || 'Text';
      const operators = this.get_condition_operators(condition);
      if (!operators.includes(condition.operator)) condition.operator = operators[0] || '=';
    },
    entity_fields_for_source(source) {
      return this.source_fields.filter((field) => field.source === source);
    },
    field_samples(condition = {}) {
      const question = this.lookup_condition_question(condition);
      if (question) return this.recent_question_samples;
      const source_field = this.source_fields.find((field) => field.source === condition.entity_source && field.field === condition.field);
      return source_field?.samples || [];
    },
    set_active_rule_tab(tab_id) {
      if (!this.is_step_unlocked(tab_id)) {
        const next_step = this.next_required_step;
        this.show_info(`Complete ${next_step?.label || 'the current step'} before opening this step.`);
        return;
      }
      this.active_rule_tab = tab_id;
      this.$router.replace({
        query: {
          ...this.$route.query,
          mode: 'builder',
          ruleId: this.selected_rule_id,
          tab: tab_id,
        },
      });
    },
    open_rule_builder(rule) {
      this.selected_rule_id = String(rule.id);
      this.current_view = 'builder';
      this.active_rule_tab = this.is_step_unlocked(this.active_rule_tab) ? this.active_rule_tab : 'rule_setup';
      this.open_rule_modal(rule);
      this.fetch_rule_assignments(this.selected_rule_id).then(() => {
        this.fetch_rule_conditions(this.selected_rule_id);
        this.fetch_rule_result_actions(this.selected_rule_id);
      });
      this.$router.push({
        name: 'ComplianceManagement',
        query: {
          ...this.$route.query,
          mode: 'builder',
          ruleId: String(rule.id),
          tab: this.active_rule_tab,
        },
      });
    },
    open_hub() {
      this.current_view = 'hub';
      const query = { ...this.$route.query };
      delete query.mode;
      delete query.ruleId;
      delete query.tab;
      this.$router.push({ name: 'ComplianceManagement', query });
    },
    open_rule_modal(rule = null) {
      this.modal_error_message = '';
      if (rule) {
        const normalized = this.normalize_rule(rule);
        this.rule_form = {
          id: normalized.id,
          mode: 'edit',
          name: normalized.name || '',
          description: normalized.description || '',
          initial_grace_period_days: normalized.initial_grace_period_days || 7,
          frequency_days: normalized.frequency_days || '',
          recurring_grace_period_days: normalized.recurring_grace_period_days || '',
          logical_operator: this.operators.includes(normalized.logic) ? normalized.logic : 'AND',
          trigger_status_id: normalized.trigger_status_id || '',
          status: normalized.status || 'Draft',
        };
        return;
      }
      this.rule_form = {
        id: null,
        mode: 'create',
        name: '',
        description: '',
        initial_grace_period_days: 7,
        frequency_days: '',
        recurring_grace_period_days: '',
        logical_operator: 'AND',
        trigger_status_id: '',
        status: 'Draft',
      };
    },
    async save_rule_setup_step() {
      const validation_message = this.validate_rule_form();
      if (validation_message) {
        this.show_error(validation_message);
        return;
      }
      await this.save_rule();
      if (this.rule_setup_complete) this.set_active_rule_tab('forms_questions');
    },
    enable_onboarding_only_rule() {
      this.rule_form.frequency_days = '';
      this.rule_form.recurring_grace_period_days = '';
    },
    continue_to_next_step() {
      const current_index = this.rule_tabs.findIndex((step) => step.id === this.active_rule_tab);
      const next_step = this.rule_tabs[current_index + 1];
      if (next_step) this.set_active_rule_tab(next_step.id);
    },
    validate_rule_form() {
      if (!this.rule_form.name.trim()) return 'Rule name is required.';
      if (!this.rule_form.logical_operator) return 'Logic is required.';
      const numeric_fields = [
        ['Initial Grace Days', this.rule_form.initial_grace_period_days, true],
        ['Frequency Days', this.rule_form.frequency_days, false],
        ['Recurring Grace', this.rule_form.recurring_grace_period_days, false],
      ];
      for (const [label, value, required] of numeric_fields) {
        if (!required && (value === '' || value === null || typeof value === 'undefined')) continue;
        const number_value = Number(value);
        if (!Number.isFinite(number_value) || number_value < 0) return `${label} should be numeric.`;
      }
      return '';
    },
    build_rule_payload() {
      const payload = {
        name: this.rule_form.name.trim(),
        description: this.rule_form.description.trim(),
        initial_grace_period: this.days_to_duration(this.rule_form.initial_grace_period_days),
        logical_operator: this.rule_form.logical_operator,
        trigger_status_ids: this.rule_form.trigger_status_id ? [Number(this.rule_form.trigger_status_id)] : [],
      };
      if (this.rule_form.id) payload.id = this.rule_form.id;
      if (this.route_entity_type_id) payload.entity_type = this.route_entity_type_id;
      const frequency = this.days_to_duration(this.rule_form.frequency_days);
      const recurring_grace = this.days_to_duration(this.rule_form.recurring_grace_period_days);
      if (frequency) payload.frequency = frequency;
      if (recurring_grace) payload.recurring_grace_period = recurring_grace;
      return payload;
    },
    async save_rule() {
      this.modal_error_message = this.validate_rule_form();
      if (this.modal_error_message) return;

      this.saving = true;
      const loader = await this.show_loader(this.rule_form.id ? 'Updating compliance rule...' : 'Creating compliance rule...');
      try {
        const url = this.rule_form.id ? UPDATE_COMPLIANCE_RULE_URL : CREATE_COMPLIANCE_RULE_URL;
        const response = await axios.post(url, this.build_rule_payload(), get_request_config());
        const response_data = this.parse_response_data(response.data);
        await this.fetch_compliance_rules();
        const saved_rule_id = response_data.rule_id || this.rule_form.id;
        if (saved_rule_id) this.selected_rule_id = String(saved_rule_id);
        await this.fetch_all_rule_assignments();
        this.close_modal('compliance_rule_modal');
        this.show_success(response_data.message || 'Compliance rule saved successfully.');
        if (!this.rule_form.id && saved_rule_id) {
          const created_rule = this.normalized_rules.find((rule) => String(rule.id) === String(saved_rule_id));
          if (created_rule) this.open_rule_builder(created_rule);
        }
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to save compliance rule.');
      } finally {
        await this.close_loader(loader);
        this.saving = false;
      }
    },
    duplicate_rule(rule) {
      this.open_rule_modal(rule);
      this.rule_form.id = null;
      this.rule_form.mode = 'create';
      this.rule_form.name = `${this.rule_form.name} Copy`;
      this.rule_form.trigger_status_id = '';
      const modal = new window.bootstrap.Modal(document.getElementById('compliance_rule_modal'));
      modal.show();
    },
    archive_rule(rule) {
      this.show_confirm(
        'Delete compliance rule?',
        'The backend currently exposes delete support, not a soft archive. This will delete the rule.',
        () => this.delete_rule(rule)
      );
    },
    async delete_rule(rule) {
      const loader = await this.show_loader('Deleting compliance rule...');
      try {
        const response = await axios.post(DELETE_COMPLIANCE_RULE_URL, { rule_id: rule.id }, get_request_config());
        const response_data = this.parse_response_data(response.data);
        await this.fetch_compliance_rules();
        this.show_success(response_data.message || 'Compliance rule deleted.');
        if (String(this.selected_rule_id) === String(rule.id)) this.open_hub();
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to delete compliance rule.');
      } finally {
        await this.close_loader(loader);
      }
    },
    async assign_selected_form_to_rule(options = {}) {
      if (!this.selected_rule_id || !this.selected_form_id) {
        this.show_error('Select a form to assign to this rule.');
        return false;
      }
        if (!this.selected_form_is_available) {
          this.show_info('This form is no longer available.');
          return false;
        }
      this.assigning = true;
      const loader = await this.show_loader('Adding form to rule...');
      try {
        await this.load_form_structure(this.selected_form_id);
        const form = this.entity_type_forms.find((item) => String(item.id) === String(this.selected_form_id));
        const total_questions = this.total_questions_for_form(this.selected_form_id);
        const response = await axios.post(
          BULK_ASSIGN_COMPLIANCE_BY_SCOPE_URL,
          {
            compliance_rule_id: Number(this.selected_rule_id),
            scope: 'form',
            scope_id: Number(this.selected_form_id),
          },
          get_request_config()
        );
        const response_data = this.parse_response_data(response.data);
        await this.fetch_rule_assignments(this.selected_rule_id);
        await this.fetch_compliance_rules();
        if (options.reset_selection) {
          this.selected_form_id = '';
        }
        this.show_success(response_data.message || `${form?.form_name || 'Form'} added successfully. ${response_data.processed_count || total_questions || 0} questions are now available to this compliance rule.`);
        return true;
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to add form.');
        return false;
      } finally {
        await this.close_loader(loader);
        this.assigning = false;
      }
    },
    async assign_selected_questions_to_rule() {
      if (!this.selected_rule_id || !this.manual_form_id) {
        this.show_error('Select a form before assigning questions.');
        return;
      }
      const question_ids = this.manual_selected_question_ids.map(Number).filter((id) => Number.isFinite(id) && id > 0);
      if (!question_ids.length) {
        this.show_error('Select at least one question to assign.');
        return;
      }
      this.assigning = true;
      const loader = await this.show_loader('Assigning selected questions...');
      try {
        const response = await axios.post(
          BULK_ASSIGN_COMPLIANCE_QUESTIONS_URL,
          {
            compliance_rule_id: Number(this.selected_rule_id),
            section_question_ids: question_ids,
          },
          get_request_config()
        );
        const response_data = this.parse_response_data(response.data);
        await this.fetch_rule_assignments(this.selected_rule_id);
        await this.fetch_compliance_rules();
        this.manual_selected_question_ids = [];
        this.show_success(response_data.message || `${response_data.processed_count || question_ids.length} selected questions were assigned to ${this.selected_rule?.name || 'this rule'}.`);
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to assign selected questions.');
      } finally {
        await this.close_loader(loader);
        this.assigning = false;
      }
    },
    async save_assignment_question_modal() {
      if (!this.assignment_question_modal.form_id) {
        this.show_error('Select a form before saving.');
        return;
      }
      if (this.assignment_question_modal.method === 'full_form') {
        if (!this.assignment_question_modal.select_all_questions) {
          this.show_error('Confirm Select All Questions before assigning the full form.');
          return;
        }
        this.selected_form_id = String(this.assignment_question_modal.form_id);
        const saved = await this.assign_selected_form_to_rule({ allow_existing: true, reset_selection: true });
        if (saved) {
          this.close_assignment_questions_modal();
          this.selected_form_id = '';
        }
        return;
      }

      const selected_ids = this.assignment_question_modal.selected_question_ids.map(Number).filter((id) => Number.isFinite(id) && id > 0);
      if (!selected_ids.length) {
        this.show_error('Select at least one question before saving this form configuration.');
        return;
      }

      this.assigning = true;
      const loader = await this.show_loader('Saving selected questions...');
      try {
        const form_id = this.assignment_question_modal.form_id;
        const current_ids = this.assigned_questions_for_form(form_id)
          .map((question) => Number(question.section_question_id || question.id))
          .filter((id) => Number.isFinite(id) && id > 0);
        const selected_set = new Set(selected_ids.map(String));
        const current_set = new Set(current_ids.map(String));
        const ids_to_assign = selected_ids.filter((id) => !current_set.has(String(id)));
        const ids_to_remove = current_ids.filter((id) => !selected_set.has(String(id)));

        if (ids_to_assign.length) {
          await axios.post(
            BULK_ASSIGN_COMPLIANCE_QUESTIONS_URL,
            {
              compliance_rule_id: Number(this.selected_rule_id),
              section_question_ids: ids_to_assign,
            },
            get_request_config()
          );
        }
        if (ids_to_remove.length) {
          await axios.post(
            BULK_UNASSIGN_COMPLIANCE_QUESTIONS_URL,
            {
              compliance_rule_id: Number(this.selected_rule_id),
              section_question_ids: ids_to_remove,
            },
            get_request_config()
          );
          this.remove_conditions_for_question_ids(ids_to_remove);
        }
        await this.fetch_rule_assignments(this.selected_rule_id);
        await this.fetch_compliance_rules();
        this.close_assignment_questions_modal();
        this.selected_form_id = '';
        this.show_success(`${this.assignment_modal_form?.form_name || 'Form'} question configuration saved.`);
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to save selected questions.');
      } finally {
        await this.close_loader(loader);
        this.assigning = false;
      }
    },
    remove_form_from_rule(form) {
      const questions = this.selected_rule_questions.filter((question) => String(question.form_id) === String(form.form_id));
      if (!questions.length) {
        this.show_info('This form has no assigned questions to remove.');
        return;
      }
      this.show_confirm(
        'Remove form from rule?',
        'This removes the form questions from the rule and clears draft conditions using those questions.',
        () => this.unassign_form_questions(form, questions)
      );
    },
    async unassign_form_questions(form, questions) {
      const section_question_ids = questions.map((question) => Number(question.section_question_id || question.id)).filter((id) => Number.isFinite(id) && id > 0);
      const loader = await this.show_loader('Removing form questions from rule...');
      try {
        await axios.post(
          BULK_UNASSIGN_COMPLIANCE_QUESTIONS_URL,
          {
            compliance_rule_id: Number(this.selected_rule_id),
            section_question_ids,
          },
          get_request_config()
        );
        this.remove_conditions_for_question_ids(section_question_ids);
        await this.fetch_rule_assignments(this.selected_rule_id);
        await this.fetch_compliance_rules();
        if (String(this.selected_form_id) === String(form.form_id)) {
          this.selected_form_id = '';
        }
        this.show_success(`${form.form_name || 'Form'} removed from this rule.`);
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to remove form from rule.');
      } finally {
        await this.close_loader(loader);
      }
    },
    async remove_question_from_rule(question) {
      if (!question?.id && !question?.section_question_id) {
        this.show_info('Remove from rule needs a section question id from the backend response.');
        return;
      }
      const loader = await this.show_loader('Removing question from rule...');
      try {
        await axios.post(
          BULK_UNASSIGN_COMPLIANCE_QUESTIONS_URL,
          {
            compliance_rule_id: Number(this.selected_rule_id),
            section_question_ids: [Number(question.section_question_id || question.id)],
          },
          get_request_config()
        );
        this.remove_conditions_for_question_ids([Number(question.section_question_id || question.id)]);
        await this.fetch_rule_assignments(this.selected_rule_id);
        await this.fetch_compliance_rules();
        this.show_success('Question removed from this rule.');
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to remove question from rule.');
      } finally {
        await this.close_loader(loader);
      }
    },
    remove_conditions_for_question_ids(question_ids = []) {
      const id_set = new Set(question_ids.map((id) => String(id)));
      this.condition_groups = this.clean_condition_groups_for_removed_questions(this.condition_groups, id_set);
    },
    clean_condition_groups_for_removed_questions(groups = [], id_set = new Set()) {
      return groups.map((group) => ({
        ...group,
        conditions: (group.conditions || []).filter((condition) => this.condition_kept_after_question_removal(condition, id_set)),
        children: this.clean_condition_groups_for_removed_questions(group.children || [], id_set),
      }));
    },
    condition_kept_after_question_removal(condition = {}, id_set = new Set()) {
      const question_id = condition.assigned_question_id || condition.question_id || condition.compliance_field_id;
      return !id_set.has(String(question_id));
    },
    save_draft() {
      if (!this.selected_rule) return;
      this.open_rule_modal(this.selected_rule);
      const modal = new window.bootstrap.Modal(document.getElementById('compliance_rule_modal'));
      modal.show();
    },
    publish_rule() {
      if (!this.ready_to_publish) {
        const blockers = this.blocking_validation_issues.map((issue) => issue.label);
        this.show_warning('Rule is not publish ready', [...blockers, ...this.missing_setup_requirements].join(', '));
        return;
      }
      this.show_info('Publish uses the existing rule update flow. Confirm trigger/status in Edit Rule before publishing.');
    },
    open_logic_modal() {
      if (this.selected_rule) this.open_rule_modal(this.selected_rule);
    },
   add_condition_group() {
    if (this.condition_group_form.mode === 'edit' && this.condition_group_form.id) {
      const index = this.condition_groups.findIndex(
        group => group.id === this.condition_group_form.id
      );
      if (index !== -1) {
        this.condition_groups.splice(index, 1, { ...this.condition_group_form });
      }
    } else {
      // create new group
      this.condition_group_form.id = Date.now(); // or backend id
      this.condition_groups.push({ ...this.condition_group_form });
    }
    
    this.condition_group_form = {
      id: null,
      mode: 'create',
      name: '',
      logic: 'AND',
      show_validation: false,
      conditions: [],
    };
  },
    add_child_condition_group(group) {
      group.children = group.children || [];
      group.children.push({
        id: Date.now(),
        logic: 'OR',
        collapsed: false,
        conditions: [{
          id: Date.now() + 1,
          source_type: 'entity_field',
          entity_source: 'Audit Submission',
          field: 'Status',
          question_type: 'Multiple choice',
          operator: 'Equals',
          value: 'Failed',
        }],
      });
    },
    add_condition(group) {
      group.conditions.push({
        id: Date.now(),
        source_type: 'form_question',
        form_id: '',
        assigned_question_id: '',
        compliance_field_id: '',
        section_name: '',
        question_id: '',
        question_type: 'Text',
        field: '',
        operator: 'Contains',
        value: '',
      });
    },
    add_question_to_conditions(question) {
      if (!question) return;
      const target_group = this.condition_groups[0] || {
        id: Date.now(),
        logic: 'AND',
        collapsed: false,
        children: [],
        conditions: [],
      };
      if (!this.condition_groups.length) this.condition_groups.push(target_group);
      target_group.conditions.push({
        id: Date.now(),
        source_type: 'form_question',
        form_id: String(question.form_id || ''),
        section_name: question.section_name || '',
        assigned_question_id: String(question.section_question_id || question.id || ''),
        compliance_field_id: String(question.compliance_field_id || question.field_id || question.section_question_id || question.id || ''),
        question_id: String(question.section_question_id || question.id || ''),
        question_type: question.question_type || 'Text',
        field: question.question_text || question.compliance_field_label || '',
        operator: '=',
        value: '',
      });
      this.selected_preview_question_id = String(question.section_question_id || question.id || '');
      this.active_rule_tab = 'conditions';
      this.show_success(`${question.question_text || 'Question'} added to draft conditions.`);
    },
    remove_condition(group, condition_id) {
      group.conditions = group.conditions.filter((condition) => condition.id !== condition_id);
    },
    toggle_condition_group(group) {
      group.collapsed = !group.collapsed;
    },
    save_conditions() {
      this.show_success('Condition summaries updated for this draft rule.');
      if (this.conditions_complete) this.set_active_rule_tab('actions');
    },
    reset_action_form() {
      this.action_form = {
        id: null,
        mode: 'create',
        outcome_type: 'fail',
        action_type: 'Manual Review',
        description: '',
        target_status: 'Manual Review',
      };
    },
    open_action_modal(action = null) {
      if (action) {
        this.action_form = {
          id: action.id,
          mode: 'edit',
          outcome_type: action.outcome_type || 'fail',
          action_type: action.action || action.action_type || 'Manual Review',
          description: action.description || '',
          target_status: action.target_status || action.action || 'Manual Review',
        };
      } else {
        this.reset_action_form();
      }
      const modal = new window.bootstrap.Modal(document.getElementById('action_config_modal'));
      modal.show();
    },
    async save_action_modal() {
      if (!this.action_form.action_type || !this.action_form.outcome_type) {
        this.show_warning('Choose an outcome and action before saving.');
        return;
      }
      if (!this.selected_rule_id) {
        this.show_warning('Save the compliance rule before adding actions.');
        return;
      }
      const payload = {
        compliance_rule_id: Number(this.selected_rule_id),
        outcome_type: this.action_form.outcome_type,
        action: this.action_form.action_type,
        action_type: this.action_form.action_type,
        description: this.action_form.description || `${this.action_form.action_type} when ${this.action_form.outcome_type} is returned.`,
        target_status: this.action_form.target_status || this.action_form.action_type,
        enabled: true,
        icon: this.action_icon(this.action_form.action_type),
        priority: this.action_priority(this.action_form.action_type),
        expanded: false,
      };
      if (this.action_form.id) payload.id = this.action_form.id;
      const loader = await this.show_loader('Saving result action...');
      try {
        const response = await axios.post(SAVE_RULE_RESULT_ACTION_URL, payload, get_request_config());
        const response_data = this.parse_response_data(response.data);
        const saved_action = this.normalize_result_action(response_data.action || payload);
        if (this.action_form.mode === 'edit') {
          this.configured_actions = this.configured_actions.map((action) => (String(action.id) === String(saved_action.id) ? saved_action : action));
        } else {
          this.configured_actions.push(saved_action);
        }
        const modal = window.bootstrap.Modal.getInstance(document.getElementById('action_config_modal'));
        if (modal) modal.hide();
        this.show_success('Action saved.');
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to save action.');
      } finally {
        await this.close_loader(loader);
      }
    },
    action_icon(action_type = '') {
      const icon_map = {
        Approve: 'bi-check2-circle',
        Reject: 'bi-x-circle',
        'Manual Review': 'bi-person-check',
        Escalate: 'bi-arrow-up-right-circle',
        'Create Audit Log': 'bi-journal-check',
      };
      return this.get_owned_value(icon_map, action_type, 'bi-lightning-charge');
    },
    action_priority(action_type = '') {
      if (['Reject', 'Escalate'].includes(action_type)) return 'High';
      if (action_type === 'Create Audit Log') return 'Low';
      return 'Medium';
    },
    action_outcome_label(action = {}) {
      const raw = String(action.outcome_type || action.evaluation_outcome || action.result || action.action || 'Manual Review');
      const match = this.action_outcomes.find((item) => String(item.id) === raw || String(item.label).toLowerCase() === raw.toLowerCase());
      if (match?.label) return match.label.replace(/^On\s+/i, '');
      return raw
        .split(/[_-]+/)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    action_description(action = {}) {
      if (action.description) return action.description;
      const target = action.target_status || action.action || action.action_type || 'the compliance queue';
      return `Move application to ${target}.`;
    },
    action_severity_badge_class(priority = 'Medium') {
      if (priority === 'High') return 'compliance-action-pill-high';
      if (priority === 'Low') return 'compliance-action-pill-low';
      return 'compliance-action-pill-medium';
    },
    normalize_result_action(action = {}) {
      const action_type = action.action_type || action.action || action.target_status || 'Manual Review';
      return {
        id: action.id || Date.now(),
        outcome_type: action.outcome_type || action.evaluation_outcome || 'fail',
        action: action_type,
        action_type,
        description: action.description || `${action_type} when ${action.outcome_type || action.evaluation_outcome || 'evaluation'} is returned.`,
        target_status: action.target_status || action_type,
        enabled: action.enabled !== false,
        icon: this.action_icon(action_type),
        priority: this.action_priority(action_type),
        expanded: false,
      };
    },
    add_action_config(action) {
      this.configured_actions.push({
        id: Date.now(),
        action: action.action,
        description: `${action.action} when this rule is triggered.`,
        enabled: true,
        icon: action.icon,
        recipients: 'Compliance officer',
        priority: action.priority || 'Medium',
        delay_minutes: 0,
        retry_count: 2,
        template: `${action.action} template`,
        conditional_execution: 'Only when rule matched',
        expanded: true,
      });
      this.show_info('Action was added to the draft UI. Backend result-action persistence is still required.');
    },
    toggle_action(action) {
      action.enabled = !action.enabled;
    },
    async remove_action_config(action_id) {
      const loader = await this.show_loader('Removing result action...');
      try {
        await axios.post(DELETE_RULE_RESULT_ACTION_URL, { action_id }, get_request_config());
        this.configured_actions = this.configured_actions.filter((action) => String(action.id) !== String(action_id));
        this.show_success('Action removed.');
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Failed to remove action.');
      } finally {
        await this.close_loader(loader);
      }
    },
    toggle_action_expanded(action) {
      action.expanded = !action.expanded;
    },
    add_assignment_target(type) {
      const value = this.assignment_search.trim();
      if (!value) {
        this.show_info('Type a user, team, department, or role before adding an assignment.');
        return;
      }
      this.assignment_targets.push({ id: Date.now(), type, name: value });
      this.assignment_search = '';
      this.auto_save_status = 'Draft changes pending';
    },
    remove_assignment_target(target_id) {
      this.assignment_targets = this.assignment_targets.filter((target) => target.id !== target_id);
    },
    save_assignments() {
      // TODO: Wire users/teams/departments/roles assignment once backend assignment endpoints exist.
      this.show_info('Assignments require backend ownership endpoints. No assignment data was saved.');
    },
    save_notifications() {
      // TODO: Wire notification settings once compliance notification endpoints exist.
      this.show_info('Notification settings require backend endpoints. No notification data was saved.');
    },
    save_escalations() {
      // TODO: Wire escalation settings once compliance escalation endpoints exist.
      this.show_info('Escalation settings require backend endpoints. No escalation data was saved.');
    },
    set_test_result(label, value, response_data = null) {
      const existing = this.test_result_cards.filter((card) => card.label !== label);
      this.test_result_cards = [{ label, value }, ...existing].slice(0, 8);
      this.test_response = response_data || this.test_response;
    },
    run_rule_simulation() {
      const matched = this.rule_condition_count > 0 && this.enabled_actions_count > 0;
      this.simulation.matched = matched;
      this.simulation.output_cards = [
        { label: 'Rule matched', value: matched ? 'Yes' : 'No', ok: matched },
        { label: 'Conditions evaluated', value: this.rule_condition_count, ok: this.rule_condition_count > 0 },
        { label: 'Actions triggered', value: matched ? this.enabled_actions_count : 0, ok: this.enabled_actions_count > 0 },
        { label: 'Audit task created', value: matched ? 'Ready' : 'Blocked', ok: matched },
      ];
      this.simulation.timeline = [
        { title: 'Sample submission loaded', meta: this.simulation.sample_submission || 'Manual sample configuration' },
        { title: matched ? 'Rule conditions matched' : 'Rule validation blocked execution', meta: `${this.rule_condition_count} condition(s) checked` },
        { title: 'Triggered actions previewed', meta: `${this.enabled_actions_count} enabled action(s)` },
        { title: 'Audit log prepared', meta: 'Configuration simulation only' },
      ];
      this.set_test_result('Simulation', matched ? 'Matched' : 'Blocked', { simulation: this.simulation });
    },
    capture_compliance_field_id(response_data) {
      const data = this.parse_response_data(response_data);
      const questions = data.questions || data.data?.questions || data.data || data.results || [];
      if (Array.isArray(questions) && questions.length) {
        const first = questions[0];
        const field_id = first.compliance_field_id || first.id;
        if (field_id) this.test_form.compliance_field_id = String(field_id);
      }
    },
    async run_check_assigned_questions() {
      await this.fetch_rule_assignments(this.selected_rule_id);
      this.set_test_result('Assigned Questions', this.selected_rule_questions.length, { questions: this.selected_rule_questions });
      this.show_success('Assigned questions refreshed.');
    },
    async run_get_rule_questions_answers() {
      if (!this.test_form.entity_profile_id) {
        this.show_error('Entity Profile ID is required.');
        return;
      }
      const response = await axios.get(
        GET_RULE_QUESTIONS_ANSWERS_URL,
        get_request_config({
          params: {
            compliance_rule_id: this.selected_rule_id,
            entity_profile_id: this.test_form.entity_profile_id,
          },
        })
      );
      const response_data = this.parse_response_data(response.data);
      this.capture_compliance_field_id(response_data);
      this.set_test_result('Rule Q&A Loaded', 'Done', response_data);
      this.show_success('Rule questions and answers loaded.');
    },
    async run_sync_answers() {
      if (!this.test_form.entity_profile_id) {
        this.show_error('Entity Profile ID is required.');
        return;
      }
      const response = await axios.post(
        SYNC_APPLICATION_ANSWERS_TO_COMPLIANCE_URL,
        { entity_profile_id: Number(this.test_form.entity_profile_id) },
        get_request_config()
      );
      const response_data = this.parse_response_data(response.data);
      this.set_test_result('Answers Synced', response_data.synced_count || response_data.count || 'Done', response_data);
      this.show_success('Onboarding answers synced to compliance.');
    },
    async run_check_stage_gate() {
      if (!this.test_form.entity_profile_id || !this.test_form.application_id || !this.selected_rule_id) {
        this.show_error('Entity Profile ID, Application ID, and Compliance Rule ID are required.');
        return;
      }
      try {
        const response = await axios.post(
          CHECK_COMPLIANCE_STAGE_GATE_URL,
          {
            entity_profile_id: Number(this.test_form.entity_profile_id),
            application_id: Number(this.test_form.application_id),
            compliance_rule_id: Number(this.selected_rule_id),
          },
          get_request_config()
        );
        const response_data = this.parse_response_data(response.data);
        this.set_test_result('Onboarding Gate', response_data.can_continue ? 'Can continue' : 'Blocked', response_data);
        if (response_data.can_continue) this.show_success('Required onboarding fields are complete.');
        else this.show_warning('Onboarding gate blocked', `${response_data.answered_total || 0} of ${response_data.required_total || 0} required fields answered.`);
      } catch (error) {
        const status = error?.response?.status;
        const response_data = this.parse_response_data(error?.response?.data || {});
        const warning = response_data.message || 'Runtime onboarding gate endpoint is not connected yet. This configuration can be saved, but automatic stage blocking requires backend support.';
        if ([404, 405, 501].includes(Number(status))) {
          this.set_test_result('Onboarding Gate Endpoint', 'Not connected', { warning, status });
          this.show_warning('Onboarding gate endpoint unavailable', warning);
          return;
        }
        throw error;
      }
    },
    async run_evaluate_compliance(label = 'Evaluation') {
      if (!this.test_form.entity_profile_id) {
        this.show_error('Entity Profile ID is required.');
        return;
      }
      const response = await axios.post(
        EVALUATE_COMPLIANCE_URL,
        { entity_profile_id: Number(this.test_form.entity_profile_id) },
        get_request_config()
      );
      const response_data = this.parse_response_data(response.data);
      this.set_test_result(label, response_data.outcome || response_data.status || 'Done', response_data);
      this.show_success('Compliance evaluation completed.');
    },
    async run_submit_test_answer() {
      if (!this.test_form.entity_profile_id || !this.test_form.compliance_field_id) {
        this.show_error('Entity Profile ID and Compliance Field ID are required.');
        return;
      }
      const response = await axios.post(
        SUBMIT_COMPLIANCE_ANSWER_URL,
        {
          compliance_field_id: Number(this.test_form.compliance_field_id),
          entity_profile_id: Number(this.test_form.entity_profile_id),
          answer: this.test_form.sample_answer,
        },
        get_request_config()
      );
      const response_data = this.parse_response_data(response.data);
      this.set_test_result('Test Answer Submitted', response_data.status || 'Done', response_data);
      this.show_success('Test compliance answer submitted.');
    },
    async run_answer_history() {
      if (!this.test_form.entity_profile_id || !this.test_form.compliance_field_id) {
        this.show_error('Entity Profile ID and Compliance Field ID are required.');
        return;
      }
      const response = await axios.get(
        GET_COMPLIANCE_ANSWER_HISTORY_URL,
        get_request_config({
          params: {
            compliance_field_id: this.test_form.compliance_field_id,
            entity_profile_id: this.test_form.entity_profile_id,
          },
        })
      );
      const response_data = this.parse_response_data(response.data);
      const history = response_data.history || response_data.data || response_data.results || [];
      this.set_test_result('Answer History', Array.isArray(history) ? history.length : 'Loaded', response_data);
      this.show_success('Answer history loaded.');
    },
    async run_start_ongoing() {
      if (!this.test_form.entity_profile_id) {
        this.show_error('Entity Profile ID is required.');
        return;
      }
      const response = await axios.post(
        START_ONGOING_COMPLIANCE_URL,
        {
          entity_profile_id: Number(this.test_form.entity_profile_id),
          compliance_rule_id: Number(this.selected_rule_id),
        },
        get_request_config()
      );
      const response_data = this.parse_response_data(response.data);
      this.set_test_result('Ongoing Started', response_data.next_evaluation || response_data.status || 'Done', response_data);
      this.show_success('Ongoing compliance cycle started.');
    },
    async run_test_action(action) {
      this.testing = true;
      const loader = await this.show_loader('Running compliance test step...');
      try {
        if (action === 'assigned') await this.run_check_assigned_questions();
        if (action === 'qa') await this.run_get_rule_questions_answers();
        if (action === 'sync') await this.run_sync_answers();
        if (action === 'stage_gate') await this.run_check_stage_gate();
        if (action === 'evaluate') await this.run_evaluate_compliance('Evaluation');
        if (action === 'submit') await this.run_submit_test_answer();
        if (action === 'reevaluate') await this.run_evaluate_compliance('Re-Evaluation');
        if (action === 'history') await this.run_answer_history();
        if (action === 'ongoing') await this.run_start_ongoing();
      } catch (error) {
        const response_data = this.parse_response_data(error?.response?.data || {});
        this.show_error(response_data.message || 'Compliance test step failed.');
        this.test_response = response_data;
      } finally {
        await this.close_loader(loader);
        this.testing = false;
      }
    },
    async bootstrap_page() {
      this.loading = true;
      try {
        this.load_onboarding_gate_config();
        await Promise.all([
          this.fetch_form_statuses(),
          this.fetch_compliance_dropdowns(),
          this.fetch_compliance_rules(),
          this.fetch_entity_type_forms(),
        ]);
        await this.fetch_all_rule_assignments();
        if (!this.selected_rule_id && this.normalized_rules.length) {
          this.selected_rule_id = String(this.normalized_rules[0].id);
        }
        if (this.selected_rule) this.open_rule_modal(this.selected_rule);
        if (this.selected_rule_id) await this.fetch_rule_conditions(this.selected_rule_id);
        if (this.selected_rule_id) await this.fetch_rule_result_actions(this.selected_rule_id);
        if (!this.is_step_unlocked(this.active_rule_tab)) this.active_rule_tab = 'rule_setup';
      } finally {
        this.loading = false;
      }
    },
    async fetch_compliance_dropdowns() {
      try {
        const response = await axios.get(GET_COMPLIANCE_DROPDOWNS_URL, get_request_config());
        const data = this.parse_response_data(response.data).data || {};
        this.compliance_dropdowns = {
          condition_types: data.condition_types || [],
          operators: data.operators || [],
          outcomes: data.outcomes || [],
          form_statuses: data.form_statuses || [],
        };
      } catch {
        this.compliance_dropdowns = {
          condition_types: [],
          operators: [],
          outcomes: [],
          form_statuses: [],
        };
      }
    },
    async fetch_form_statuses() {
      try {
        const response = await axios.get(GET_ALL_FORM_STATUSES_URL, get_request_config());
        this.form_statuses = this.extract_items(response.data, 'data');
      } catch {
        this.form_statuses = [];
      }
    },
    async fetch_compliance_rules() {
      try {
        const params = this.route_entity_type_id ? { entity_type_id: this.route_entity_type_id } : {};
        const response = await axios.get(GET_COMPLIANCE_RULES_URL, get_request_config({ params }));
        this.rules = this.extract_items(response.data, 'rules');
      } catch (error) {
        this.rules = [];
        this.show_error(error?.response?.data?.message || 'Failed to load compliance rules.');
      }
    },
    async fetch_entity_type_forms() {
      try {
        const response = await axios.get(GET_FORMS_URL, get_request_config());
        const forms = this.extract_items(response.data, 'data');
        this.entity_type_forms = forms.map((form) => ({
          id: form.id || form.form_id,
          form_name: form.form_name || form.name || `Form ${form.id || form.form_id}`,
          form_type: form.form_type || form.type || '',
          last_updated: form.date_updated || form.updated_at || form.date_created,
        })).filter((form) => form.id);
      } catch {
        try {
          const response = await axios.get(GET_ENTITY_TYPE_FORMS_COMPLIANCE_URL, get_request_config());
          this.entity_type_forms = this.extract_items(response.data, 'data');
        } catch {
          this.entity_type_forms = [];
        }
      }
    },
    async fetch_rule_assignments(rule_id) {
      if (!rule_id) return;
      try {
        const response = await axios.get(
          GET_ASSIGNED_QUESTIONS_FOR_RULE_URL,
          get_request_config({ params: { compliance_rule_id: rule_id } })
        );
        const forms = this.extract_items(response.data, 'data').map((form) => ({
          ...form,
          rule_id: String(rule_id),
        }));
        await Promise.all(forms.map((form) => this.load_form_structure(form.form_id).catch(() => [])));
        this.rule_assignments = {
          ...this.rule_assignments,
          [String(rule_id)]: forms,
        };
      } catch {
        this.rule_assignments = {
          ...this.rule_assignments,
          [String(rule_id)]: [],
        };
      }
    },
    condition_operator_label(operator_id) {
      const operator = (this.compliance_dropdowns.operators || []).find((item) => String(item.id) === String(operator_id));
      return operator?.operator || '=';
    },
    condition_group_from_backend(conditions = []) {
      if (!conditions.length) return [];
      return [{
        id: `backend-${this.selected_rule_id}`,
        compliance_rule_id: Number(this.selected_rule_id),
        group_name: 'Saved Conditions',
        group_logic: this.selected_rule?.logic || 'AND',
        name: 'Saved Conditions',
        logic: this.selected_rule?.logic || 'AND',
        collapsed: true,
        children: [],
        conditions: conditions.map((condition) => {
          const assignment = (condition.field_assignments || [])[0] || {};
          const compliance_field_id = assignment.compliance_field || '';
          const assigned_question = this.selected_rule_questions.find((question) => String(question.compliance_field_id || question.field_id) === String(compliance_field_id));
          const meta = Array.isArray(condition.selected_options) ? condition.selected_options[0] || {} : {};
          const assigned_question_id = String(
            assigned_question?.section_question_id ||
            meta.section_question_id ||
            condition.id
          );
          return {
            id: condition.id,
            backend_condition_id: condition.id,
            source_type: 'form_question',
            form_id: String(assigned_question?.form_id || meta.form_id || ''),
            assigned_question_id,
            compliance_field_id: String(compliance_field_id || assigned_question?.compliance_field_id || ''),
            question_id: assigned_question_id,
            question_model_id: assigned_question?.id || '',
            section_name: assigned_question?.section_name || '',
            question_type: assigned_question?.question_type || 'Text',
            field: assigned_question?.question_text || assignment.question_text || meta.question_text || 'Assigned question',
            operator: meta.operator || this.condition_operator_label(condition.condition_operator),
            value: condition.value || meta.value || '',
          };
        }),
      }];
    },
    async fetch_rule_conditions(rule_id) {
      if (!rule_id) return;
      try {
        const response = await axios.get(
          GET_RULE_CONDITIONS_URL,
          get_request_config({ params: { rule_id } })
        );
        const response_data = this.parse_response_data(response.data);
        const conditions = response_data.conditions || [];
        this.condition_groups = this.condition_group_from_backend(conditions);
      } catch {
        this.condition_groups = [];
      }
    },
    async fetch_rule_result_actions(rule_id) {
      if (!rule_id) return;
      try {
        const response = await axios.get(
          GET_RULE_RESULT_ACTIONS_URL,
          get_request_config({ params: { rule_id } })
        );
        const response_data = this.parse_response_data(response.data);
        this.configured_actions = (response_data.actions || []).map((action) => this.normalize_result_action(action));
      } catch {
        this.configured_actions = [];
      }
    },
    async fetch_all_rule_assignments() {
      const rule_ids = this.rules.map((rule) => String(rule.id)).filter(Boolean);
      await Promise.all(rule_ids.map((rule_id) => this.fetch_rule_assignments(rule_id)));
    },
  },
};
